function init(){
const classes = {
	wrapperClass: 'buy__form-wrapper',
	touristClass: 'buy__form-tourist',
	contentClass: 'buy__form-content',
	groupClass: 'buy__form-group',
	dateClass: 'buy__form-date',
	errorClass: 'buy__form-error',
	additionClass: 'buy__form-addition',
	shortClass: 'buy__form-addition--short',
	activeBodyClass: 'buy__form-body--active',
	detailsClass: 'buy__form-details',
	tableClass: 'buy__form-table',
	navigationClass: 'air-datepicker--navigation',
	pickerClass: 'air-datepicker--info',
}
const images = {
	plus: '/img/icons/plus.svg',
	trash: '/img/icons/trash.svg',
	arrow: '/img/icons/arrow-right-black.svg',
};
const buyForm = document.getElementsByClassName('buy__form')[0];
const defaults = getFormDefaults();
const body = document.body;
const mainStyle = document.getElementById('main_style');
const mainScrypt = document.getElementById('main_script');
// const loadOnceItiLib = runOnce(loadItiLib);
let isPickerLoaded = false;
const loadSwiperLibOnce = runOnce(loadSwiperLib);
const loadLibsOnce = runOnce(() => {
	loadItiLib();
	loadAirPickerLib();
	loadSwiperLibOnce();
	// loadScalioLib();
});
const menus = {
	contact: {
		triggerClass:'header__contact',
		contentClass: 'header__contact-list',
	},
	headerLanguage: {
		triggerClass:'header__language',
		contentClass: 'header__language-list',
	},
	headerMenu: {
		triggerClass:'header__menu',
		contentClass: 'header__menu-body',
	},
	footerLanguage: {
		triggerClass:'footer__language',
		contentClass: 'footer__language-list',
	},
	footerSubmenus: {
		triggerClass:'footer__card-menu-item',
		contentClass: 'footer__card-sublist',
	},
}
const tabs = {
	links: {
		triggerClass:'header__links',
	},
	contacts: {
		triggerClass:'header__contacts',
	},
	suitable: {
		triggerClass:'situable-for__card-title',
		contentClass: 'situable-for__card-description',
	},
	tariffOptions: {
		triggerClass:'tariffs__option',
		contentClass: 'tariffs__option-list',
	},
	faq: {
		triggerClass:'faq__card-question',
		contentClass: 'faq__card-answer',
	},
	footer: {
		triggerClass:'footer__card-title',
		contentClass: 'footer__card-list',
	},
}
const selects = {
	buySelect: 	{
		triggerClass:'buy__form-control--select',
		contentClass: 'buy__form-control--list',
	}
};
const multiSelects = {
	buyMultiSelect: 	{
		triggerClass:'buy__form-control--multiselect',
		contentClass: 'buy__form-control--list',
	}
};
const mores = {
	faq: {
		triggerClass: 'faq__more',
		hideContentClass: 'faq__card--hidden',
		showedListLength: 8,
	},
	footer: {
		triggerClass: 'footer__more',
		hideContentClass: 'footer__card-list--hidden',
		showedListLength: 11,
	},
}
const closeAllMenus = closeMenus(menus);
const showModalById = showModal({
	closeButtonClass: 'popup__modal-close',
	modalContentClass: 'modal',
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const hideCurrentModal = hideModal({
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const linearTimerView = createTimerViewHandler({
	labelClass: 'discount__timer',
	progressClass: 'discount__bar',
	millisecondsClass: 'discount__timer--active',
	timerType: 'linear',
})
const circleTimerView = createTimerViewHandler({
	labelClass: 'timer__stop',
	progressClass: 'timer__progress',
	millisecondsClass: 'timer__stop--active',
	timerType: 'circle',
})
const updateBuyFormPrice = debounce(updatePrice(buyForm, ({ currency, price, discountPrice, isDiscount, promo_code, valid_code, code_type, code_value, esim_info }) => {
	for (const wrapper of document.getElementsByClassName('buy__form-subheader-price')) {
		wrapper.innerHTML = '';

		if (price > 0) {
			updateFormHeaderPriceView(wrapper, {currency, price, discountPrice, isDiscount});
		}
	}

	for (const wrapper of document.getElementsByClassName('buy__form-prices')) {
		wrapper.innerHTML = '';

		if (price > 0) {
			// updateFormFooterPriceView(wrapper, { currency, price, discountPrice, isDiscount });
			updateFormFooterPriceViewNew(wrapper, { currency, price, discountPrice, isDiscount, isPromo: valid_code });
		}
	}

	updateInfoESIM(esim_info);

	const promoCodeInputs = Array.from(document.querySelectorAll('input[name="promo"]'));
	const groupClass = 'buy__form-group';

	if (!promoCodeInputs.length || !promo_code) {
		return;
	}

	promoCodeInputs.forEach(promoCodeInput => {
		if (!promoCodeInput.value) {
			return;
		}

		hidePromoSuccess({ target: promoCodeInput });
		removeClassFromElement(promoCodeInput.closest('.' + groupClass), groupClass, '--error');

		if (!valid_code) {
			addClassToElement(promoCodeInput.closest('.' + groupClass), groupClass, '--error');
		} else {
			const promoLabelElement = promoCodeInput.nextElementSibling.lastElementChild;

			showPromoSuccess({ target: promoCodeInput });
			promoLabelElement.textContent = setDiscountValue(code_value, code_type) + ' ' + labels.promoDiscount;
		}

	})
}), 200);
// const timestampLimit = 60 * 1000 || 3 * 60 * 60 * 1000;
// let timer = null;
const timer = createTimer('discountTimestamp', timestamp, timestampLimit, 1000, (timestamp, timestampLimit) => {
	linearTimerView.update(timestamp, timestampLimit);
	circleTimerView.update(timestamp, timestampLimit);
}, () => {
	updateTariffsCardPrice();
	updateBuyFormPrice();

	const circleTimer = document.querySelector('.timer__stop');
	const linearTimer = document.querySelector('.discount__timer');

	addClassToElement(circleTimer, 'timer__stop--stopped');
	addClassToElement(linearTimer, 'discount__timer--stopped');

	const circleTitle = document.querySelector('.timer__percent');
	const linearTitle = document.querySelector('.discount__title');

	if (circleTitle) {
		circleTitle.innerHTML = `
			<img src="/img/icons/clock.png" alt="Clock">
		`;
		// circleTitle.innerHTML = clockSvg;
	}

	if (linearTitle) {
		linearTitle.innerHTML = `
			<span>${labels.discount} <b>-37%</b> ${labels.isOver}</span>
		`;
	}

	const circleDescription = document.querySelector('.timer__sale');
	const linearDescription = document.querySelector('.discount__persent');

	if (circleDescription) {
		circleDescription.innerHTML = `
			<p>${labels.discount} <span>-37%</span> <br>${labels.isOver}</p>
		`;
	}

	if (linearDescription) {
		linearDescription.innerHTML = `
			<img src="/img/icons/clock.png" alt="Clock">
		`;
		// linearDescription.innerHTML = clockSvg;
	}
});
const toggleBuyFormHeader = toggleFormHeader({
	formElement: buyForm,
	formHeaderClass: 'buy__form-subheader',
})
const toggleBuyFormCheckbox = toggleCheckbox({triggerClass: 'buy__form-control--checkbox', checkedClass: 'buy__form-control--checked', toggleClass:'buy__form-control-toggle'})
const focusDateInput = focusInput({ triggerClass: 'buy__form-date' });
const updateDurationView = updateDaysDiffView({ viewClass: 'buy__form-hint' });
const setBuyFormStep = setStep({
	stepClass: 'buy__step', tabClass: 'buy__tab', bodyClass: 'buy__form-body'
});
const checkBuyInputValue = checkInput({ groupClass: 'buy__form-group' });
const hideBuyInputError = hideError({ groupClass: 'buy__form-group' });
const buySelect = toggleSelect(selects.buySelect);
const buyMultiSelect = toggleSelect(multiSelects.buyMultiSelect);
const showPromoSuccess = showSuccess({ groupClass: 'buy__form-promo' });
const hidePromoSuccess = hideSuccess({ groupClass: 'buy__form-promo' });
const multiSelect = createMultiSelect({ multiSelectClass: 'buy__form-control--multiselect' });
// const anchorActions = {
// 	openModal: ({ openModal }) => {
// 		closeAllMenus();
//
// 		// if (openModal === 'cooperate-modal') {
// 		// 	loadOnceItiLib(true);
// 		// }
//
// 		showModalById(openModal);
// 	},
// 	setInput: ({ setInput, text, value }) => {
// 		setInputValue({ setInput, text, value },'buy__form-control--selected');
// 	},
// 	setFormStep: ({ setFormStep }) => {
// 		const isValid = isBuyFormStepComplete(setFormStep, buyForm);
//
// 		if (isValid) {
// 			setBuyFormStep(parseInt(setFormStep));
// 		}
// 	},
// }
// const timeLabelElements = getCountryTimeLabelElements([
// 	'header__contact-time',
// 	'header__contacts-time',
// 	'footer__card-time',
// ]);
const syncNameInputs = createSyncInputsValues(['input[name="insurer_name"]']);
const syncLastNameInputs = createSyncInputsValues(['input[name="insurer_lastname"]']);
const syncPassportInputs = createSyncInputsValues(['input[name="insurer_passport"]']);
const syncBirthdayInputs = createSyncInputsValues(['input[name="insurer_birthday"]']);
const syncPromoInputs = createSyncInputsValues(['input[name="promo"]']);
const keyboardClickHandler = createKeyboardClickHandler({
	triggerClass: 'buy__form-control--select',
	selectedClass: 'buy__form-control--selected',
});
const swiperElements = Array.from(document.getElementsByClassName('swiper'));


if (swiperElements.some(isElementPartiallyVisible)) {
	loadSwiperLibOnce();
}


const queryParams = getUsersQueryParams();
const isFailedPayment = queryParams.hasOwnProperty('payment_status')
	&& ['declined', 'cancelled'].includes(queryParams.payment_status);
const default_system = queryParams.system || 'telr';
const payment_system = default_system === 'telr' ? 'paytabs' : 'telr';

if (isFailedPayment) {
	showModalById('retry-modal');
	updateURLSearch({
		payment_status: '',
		c_m: default_system,
	})
}

if (timestamp) {
	updateBuyFormPrice();
}

for (const prop in menus) {
	const closeAllMenusWithoutSelects = (target) => {
		if (target.closest('.buy__form-control--select--active')) {
			return;
		}

		closeAllMenus;
	}

	body.addEventListener('click', toggleMenu(menus[prop], closeAllMenus));
}

for (const prop in tabs) {
	body.addEventListener('click', toggleTab(tabs[prop]));
}

for (const prop in mores) {
	const moreElements = document.getElementsByClassName(mores[prop].triggerClass)
	const toggleMoreCb = toggleMore(mores[prop])

	for (const moreElement of moreElements) {
		toggleMoreCb({ target: moreElement });
	}

	body.addEventListener('click', toggleMoreCb);
}

localStorage.setItem('ga_step', 0);
localStorage.setItem('ga_old_step', 0);
localStorage.setItem('analytics_form_step', '0');
dynamicTextTyping();
setCooperateFormHandlers();
setToDirectorFormHandlers();
setBuyFormHandlers(buyForm);
// setLanguagesAndLinks([
// 	...document.getElementsByClassName('header__language-list'),
// 	...document.getElementsByClassName('footer__language-list'),
// ]);
// setCountryTimeLabelOffsetAndTime(timeLabelElements);
setRefreshCountryTimeInterval();
setTariffs({
	cardClass: 'tariffs__card',

});
updateTariffsCardPrice(timestamp);
body.addEventListener('click', (e) => {
	const { target } = e;

	for (const prop in menus) {
		const { triggerClass, contentClass } = menus[prop];
		const menuTrigger = target.closest('.' + triggerClass);
		const menuContent = target.closest('.' + contentClass);

		if (menuTrigger || menuContent) {
			return;
		}
	}

	closeAllMenus();
});
body.addEventListener('click', (e) => {
	const { target } = e;
	const button = target.closest('button');

	if(button && button.dataset.showHint) {
		return;
	}

	hideAllHints();
});
body.addEventListener('click', (e) => {
	const { target } = e;
	const { triggerClass, hideAllLists } = buySelect;
	const selectTrigger = target.closest('.' + triggerClass);

	if (selectTrigger) {
		return;
	}

	hideAllLists();
});
body.addEventListener('click', (e) => {
	const { target } = e;
	const { triggerClass, hideAllLists } = buyMultiSelect;
	const selectTrigger = target.closest('.' + triggerClass);

	if (selectTrigger) {
		return;
	}

	hideAllLists();
	showAddTouristBtn();

	// const { groupWrapper, validate } = multiSelect;
	//
	// if (!validate()) {
	// 	addClassToElement(groupWrapper, 'buy__form-group', '--error');
	// }
});
body.addEventListener('click', anchorClickHandler);
body.addEventListener('click', buttonClickHandler);
body.addEventListener('click', liClickHandler);
body.addEventListener('click', toggleBuyFormCheckbox);
body.addEventListener('click', focusDateInput);
document.addEventListener('keydown', keyboardClickHandler)
document.addEventListener('scroll', toggleBuyFormHeader);

window.addEventListener('click', loadLibsOnce, { once: true });
window.addEventListener('scroll', loadLibsOnce, { once: true });
window.addEventListener('mousemove', loadLibsOnce, { once: true });
window.addEventListener('touchstart', loadLibsOnce, { once: true });
loadGoogleAnalytics();
// downloadOptions({
// 	url: '/api/get_country_list',
// 	method: 'GET',
// 	inputSelector: 'input[name="territory"]',
// 	dataAttribute: 'data-set-input',
// 	attributeValue: 'territory',
// });
downloadMultiOptions({
	url: '/api/get_country_list',
	method: 'GET',
	inputSelector: 'input[name="territories"]',
	dataAttribute: 'data-set-input',
	attributeValue: 'territories',
});
// setTimeout(loadOnceItiLib, 4 * 1000);

let resetForm = null;
// loadAirPickerLib();
// Datepicker start
// const buyFormDatePicker = new AirDatepicker('#date', {
// 	range: true,
// 	multipleDatesSeparator: ' - ',
// 	selectedDates: [defaults.date_start, defaults.date_end],
// 	minDate: defaults.date_start,
// 	maxDate: defaults.max_date,
// 	// isMobile: true,
// 	locale: {
// 		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
// 		daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
// 		daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
// 		months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
// 		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
// 		today: 'Today',
// 		clear: 'Clear',
// 		timeFormat: 'hh:mm aa',
// 		firstDay: 0
// 	},
// 	navTitles: {
// 		days: 'MMMM <i>yyyy</i>'
// 	},
// 	onShow: (isFinished) => {
// 		if (isFinished) {
// 			return;
// 		}
//
// 		const { insertHeader, updateHeaderLabels } = pickerHeader;
// 		const formattedDate = buyFormDatePicker.$el.value.split(defaults.date_separator);
//
// 		insertHeader();
// 		updateHeaderLabels({ formattedDate });
// 	},
// 	onSelect: ({date, formattedDate, datepicker}) => {
// 		const { updateHeaderLabels } = pickerHeader;
//
// 		updateHeaderLabels({ formattedDate });
// 		updateDurationView({ formattedDate });
// 		if (date.length < 2) {
// 			return;
// 		}
//
// 		datepicker.hide();
// 	},
// 	onHide: (isFinished) => {
// 		if (!isFinished) {
// 			return;
// 		}
//
// 		const input = buyFormDatePicker.$el;
// 		const isValid = validateDateInput(input);
// 		const groupClass = 'buy__form-group';
// 		const groupElement = input.closest('.' + groupClass);
//
// 		if (!isValid) {
// 			addClassToElement(groupElement, groupClass, '--error');
// 		}
// 	}
// });
// const resetForm = resetBuyFormValues(buyForm, buyFormDatePicker);
// const pickerHeader = datePickerHeaderHandler({
// 	navigationClass: classes.navigationClass,
// 	headerClass: classes.pickerClass,
// }, (e) => {
// 	const button = e.target.closest('button');
//
// 	if (button) {
// 		buyFormDatePicker.hide()
// 	}
// });
// Datepicker end

// Intel tel input start
// setItiPhoneInputs(intlTelInput);
// Intel tel input end

// Sliders start
// const reviewsSlider = new Swiper(".reviews__slider", {
// 	// autoplay: {
// 	// 	delay: 2000,
// 	// },
// 	// loop: true,
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true,
// 	},
// 	navigation: {
// 		nextEl: '.reviews__arrow--next',
// 		prevEl: '.reviews__arrow--prev',
// 	},
// 	breakpoints: {
// 		320: {
// 			slidesPerView: 1,
// 			spaceBetween: 10,
// 			loop: false,
// 		},
// 		481: {
// 			slidesPerView: 2,
// 			spaceBetween: 10,
// 		},
// 		992: {
// 			slidesPerView: 3,
// 			effect: "coverflow",
// 			coverflowEffect: {
// 				rotate: 0,
// 				stretch: -50,
// 				depth: 30,
// 				modifier: 1,
// 				slideShadows: false,
// 			},
// 		},
// 		1200: {
// 			slidesPerView: 5,
// 			effect: "coverflow",
// 			spaceBetween: 10,
// 			coverflowEffect: {
// 				rotate: 0,
// 				stretch: -50,
// 				depth: 30,
// 				modifier: 1,
// 				slideShadows: false,
// 			},
// 		}
// 	},
// });
// reviewsSlider.on('activeIndexChange', (swiper) => {
// 	setDisabledState(swiper, 'reviews__arrow');
// });
// const tariffsSlider = new Swiper(".tariffs__slider", {
// 	slidesPerView: 3,
// 	spaceBetween: 10,
// 	navigation: {
// 		nextEl: '.tariffs__arrow--next',
// 		prevEl: '.tariffs__arrow--prev',
// 	},
// 	breakpoints: {
// 		320: {
// 			slidesPerView: 1
// 		},
// 		480: {
// 			slidesPerView: 1,
// 			spaceBetween: 10,
// 		},
// 		// 769: {
// 		// 	slidesPerView: 2,
// 		// 	// spaceBetween: 20,
// 		// },
// 		993: {
// 			slidesPerView: 3,
// 			spaceBetween: 20,
// 		},
// 	}
// });
// tariffsSlider.slideTo(1, 400);
// tariffsSlider.on('activeIndexChange', (swiper) => {
// 	setDisabledState(swiper, 'tariffs__arrow');
// });
// const trustUsSwiper = new Swiper(".trust-us__cards", {
// 	// autoplay: {
// 	// 	delay: 2000,
// 	// },
// 	// loop: true,
// 	spaceBetween: 10,
// 	navigation: {
// 		nextEl: '.trust-us__arrow--next',
// 		prevEl: '.trust-us__arrow--prev',
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true,
// 	},
// 	breakpoints: {
// 		320: {
// 			slidesPerView: 1,
// 		},
// 		481: {
// 			slidesPerView: 2
// 		},
// 		769: {
// 			slidesPerView: 3
// 		},
// 		993: {
// 			slidesPerView: 4
// 		},
// 	}
// });
// trustUsSwiper.on('activeIndexChange', (swiper) => {
// 	setDisabledState(swiper, 'trust-us__arrow');
// });
// Sliders end

function setItiPhoneInputs (intlTelInput) {
	if (!intlTelInput) {
		return;
	}

	// const default_country_code = 'us';
	const setCountryCode = (country) => {
		intlTelInput(document.getElementById('cooperate_phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
		intlTelInput(document.getElementById('phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
		intlTelInput(document.getElementById('to_director_phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
	}

	getCountryCode().then(setCountryCode);

	// sendRequest('https://ipapi.co/json')
	// 	.then((res) => res.json())
	// 	.then(({ country_code }) => {
	// 		setCountryCode(country_code || default_country_code)
	// 	})
	// 	.catch(e => {
	// 		setCountryCode(default_country_code)
	// 	});
}
function downloadOptions ({ url, method, inputSelector, dataAttribute, attributeValue  }, withLinks = false) {
	const getOptionListWrapperElement = (inputSelector) => {
		return  document.querySelector('input[name=territory]').parentElement;
	}
	const getOptionListElement = (element) => {
		return element ? element.lastElementChild.firstElementChild : null;
	}
	const getLinksListElement = (element) => {
		return element ? element.parentElement.lastElementChild : null;
	}
	const createLinkListElement = (id, text, associationText, dataAttribute, attributeValue) => {
		const li = document.createElement('li');
		const a = document.createElement('a');

		a.textContent = associationText;
		a.href = '#';
		a.setAttribute(defaults.text_attribute_name || 'data-text', text);
		a.setAttribute(defaults.id_attribute_name || 'data-value', id);
		a.setAttribute(dataAttribute, attributeValue);
		li.appendChild(a);

		return li;
	}
	const wrapper =  getOptionListWrapperElement(inputSelector);
	const optionList = getOptionListElement(wrapper);
	const linkList = getLinksListElement(wrapper);

	sendRequestAndSaveToken(url, { method })
		.then(({ response }) => {
			if (!response || !response.success) {
				return;
			}

			const { countries_list } = response;
			const linksAssociations = {
				'207': 'Worldwide',
				'208': 'Europe',
				'100': 'Thailand',
				'107': 'USA',
			}
			const optionElements = [];
			const linkElements = [];

			optionList.innerHTML = '';
			linkList.innerHTML = '';
			countries_list.forEach(({id, text}) => {
				const associationText = linksAssociations[`${id}`];

				if (associationText) {
					linkElements.push(createLinkListElement(id,text, associationText, dataAttribute, attributeValue));
				}

				optionElements.push(createLinkListElement(id,text, text, dataAttribute, attributeValue));
				updateSelectedItem(optionElements, defaults.territory_id, 'buy__form-control--selected');
			})
			optionList.append(...optionElements);
			linkList.append(linkElements[3], linkElements[0], linkElements[1], linkElements[2]);
		}).catch(e => console.error(e.message))
}
function checkPromoCode (e){
	const { value } = e.target;

	if (!value) {
		return;
	}

	sendRequestAndSaveToken('/api/check_promo_code', {
		method: 'POST', body:JSON.stringify({ promo_code: value })
	}).then(({ response }) => {
		if (!response || !response.success) {
			const groupClass = 'buy__form-group';

			addClassToElement(e.target.closest('.' + groupClass), groupClass, '--error');

			return;
		}

		showPromoSuccess(e);
	}).catch(e => console.error(e.message))
}
function setDisabledState(swiper, arrowClass, modifier = '--disabled') {
	const arrows = document.getElementsByClassName(arrowClass);
	const prev = arrows[0];
	const next = arrows[1];
	if (!prev || !next) {
		return;
	}
	removeClassFromElement(prev, arrowClass, modifier);
	removeClassFromElement(next, arrowClass, modifier);
	if (swiper.isBeginning) {
		addClassToElement(prev, arrowClass, modifier);
	}
	if (swiper.isEnd) {
		addClassToElement(next, arrowClass, modifier);
	}
}
function throttle(fn, delay) {
	let lastCall = 0;

	return function (...args) {
		const now = Date.now();

		if (now - lastCall >= delay) {
			fn.apply(this, args);
			lastCall = now;
		}
	};
}
function debounce(fn, delay) {
	let timeoutId;

	return function (...args) {
		clearTimeout(timeoutId);

		timeoutId = setTimeout(() => {
			fn.apply(this, args);
		}, delay);
	};
}
function dateToHumanFormat (date, withDotsSeparator = false) {
	const [ year, month, day ] = [
		date.getFullYear(),
		date.getMonth() + 1,
		date.getDate(),
	].map(n => n < 10 ? `0${n}` : n);

	return withDotsSeparator ? `${day}.${month}.${year}` : `${year}-${month}-${day}`;
}
function normalizeDate (date) {
	return date.split('.').reverse().join('-');
}
function normalizeDetails ({ date, territory_id, countries, isTravelling, type_id, promo, tariff_id, isSubscription }) {
	let [ date_from,  date_to ] = date.split(' - ').map(normalizeDate);

	if (!isPickerLoaded && !date) {
		date_from = dateToHumanFormat(defaults.date_start);
		date_to = dateToHumanFormat(defaults.date_end);
	}

	return {
		date_from,
		date_to,
		// countries: [ territory_id ],
		countries,
		already_traveling: isTravelling,
		travel_type: type_id,
		promo_code: promo || null,
		program_id: tariff_id,
		is_subscription: isSubscription,
	};
}
function normalizePerson (person) {
	const normalizedPerson = {}
	const associations = {
		birthday: 'date_birth',
		name: 'first_name',
		lastname: 'last_name',
	}

	for (const prop in person) {
		if (associations.hasOwnProperty(prop)) {
			normalizedPerson[associations[prop]] = person[prop];
		} else {
			normalizedPerson[prop] = person[prop];
		}
	}

	if (normalizedPerson.date_birth) {
		normalizedPerson.date_birth = normalizeDate(normalizedPerson.date_birth);
	}

	return normalizedPerson;
}
function daysDiff (dates) {
	const regExp = /^\d{2}\.\d{2}\.\d{4} - \d{2}\.\d{2}\.\d{4}$/;

	if (!regExp.test(dates)) {
		return 0;
	}

	const {abs} = Math;
	const day = 24 * 60 * 60 * 1000;
	const [startDate, endDate] = dates
		.split(' - ')
		.map(date => (new Date(normalizeDate(date))).valueOf());
	return abs((startDate - endDate) / day) + 1;
}
function dateInputMask(e) {
	const {tagName, name} = e.target;
	if (tagName !== 'INPUT' || name.indexOf('birthday') === -1) {
		return;
	}
	let input = e.target;
	let value = input.value.replace(/[^+\d]/g, '');
	let len = value.length;
	if (e.keyCode < 47 || e.keyCode > 57) {
		e.preventDefault();
	}
	if (len !== 1 || len !== 3) {
		if (e.keyCode == 47) {
			e.preventDefault();
		}
	}
	if (e.keyCode !== 8 && e.keyCode !== 46) {
		if (len < 2) {
			input.value = value;
		}
		if (len === 2) {
			if (e.keyCode !== 8 && e.keyCode !== 46) {
				input.value = value + '.';
			}
		}
		if (len === 3) {
			input.value = value.substring(0, 2) + '.' + value.substring(2, 3);
		}
		if (len === 4) {
			input.value = value.substring(0, 2) + '.' + value.substring(2, 4) + '.';
		}
		if (len > 5) {
			input.value = value.substring(0, 2) + '.' + value.substring(2, 4) + '.' + value.substring(4, 8);
		}
	}
}
function updateDaysDiffView ({ viewClass }) {
	const day = 24 * 60 * 60 * 1000;
	const view = document.getElementsByClassName(viewClass)[0];

	return ({date, formattedDate, datepicker}) => {
		const viewLabel = view.lastElementChild;
		const duration = daysDiff(formattedDate.join(' - '));

		viewLabel.textContent = duration + ' ' + viewLabel.textContent.split(' ')[1];
	}
}
function focusInput ({ triggerClass }) {
	return (e) => {
		const { target } = e
		const isDate = target.classList.contains(triggerClass);

		if (isDate) {
			target.getElementsByTagName('input')[0].focus();
		}
	}
}
// function toggleFormHeader ({ formElement, formHeaderClass }) {
// 	const modifier = '--active';
// 	const formHeader = document.getElementsByClassName(formHeaderClass)[0];
//
// 	return (e) => {
// 		const {top} = formElement.getBoundingClientRect();
//
// 		if (top < 0) {
// 			addClassToElement(formHeader, formHeaderClass, modifier);
// 		} else if (top > 0) {
// 			removeClassFromElement(formHeader, formHeaderClass, modifier);
// 		}
// 	}
// }
function toggleFormHeader({ formElement, formHeaderClass }) {
	let cachedTop = null;
	let ticking = false;

	return (e) => {
		if (!ticking) {
			requestAnimationFrame(() => {
				const modifier = '--active';
				const offsetTop = 10;
				const {top} = formElement.getBoundingClientRect();
				const formHeader = document.getElementsByClassName(formHeaderClass)[0];

				cachedTop = top - offsetTop;

				if (cachedTop < 0) {
					addClassToElement(formHeader, formHeaderClass, modifier);
				} else if (cachedTop > 0) {
					removeClassFromElement(formHeader, formHeaderClass, modifier);
				}
				ticking = false;
			});
			ticking = true;
		}
	}
}
function toggleSelect ({ triggerClass }) {
	const modifier = '--active';
	const showSelectList = (e) => {
		const { target } = e;
		const menuTrigger = target.closest('.' + triggerClass);

		hideAllLists();
		addClassToElement(menuTrigger, triggerClass, modifier);
	}

	const hideAllLists = () => {
		const collection = document.getElementsByClassName(triggerClass);

		for (const collectionElement of collection) {
			removeClassFromElement(collectionElement, triggerClass, modifier);
		}
	}
	const hideSelectList = (e) => {
		const { target } = e;
		const menuTrigger = target.closest('.' + triggerClass);

		removeClassFromElement(menuTrigger, triggerClass, modifier);
	}
	const toggleSelectList = (e) => {
		const { target } = e;
		const menuTrigger = target.closest('.' + triggerClass);

		menuTrigger.classList.toggle(triggerClass + modifier);
	}

	return {
		triggerClass,
		showSelectList,
		hideSelectList,
		toggleSelectList,
		hideAllLists,
	}
}
function createPromoBlock ()  {
	const label = document.createElement('label');
	const wrapper = document.createElement('div');
	const input = document.createElement('input');
	const pDescription = document.createElement('p');
	const spanApprove = document.createElement('span');
	const spanDiscount = document.createElement('span');
	const p = document.createElement('p');

	label.setAttribute('for', 'promo');
	label.textContent = labels.promoLabel;
	input.setAttribute('type', 'text');
	input.setAttribute('name', 'promo');
	input.setAttribute('placeholder', labels.promoPlaceholder);
	input.setAttribute('autocomplete', 'off');
	input.addEventListener('focus', hidePromoSuccess);
	input.addEventListener('input', filterNonLatin);
	// input.addEventListener('blur', checkPromoCode);
	input.addEventListener('blur', (e) => {
		// if (e.target.value) {
		updateBuyFormPrice();
		// }
	});
	input.addEventListener('keyup', syncPromoInputs.listener);
	input.addEventListener('focus', hideBuyInputError);
	spanApprove.textContent = labels.promoSuccess;
	spanDiscount.textContent = '10% ' + labels.promoDiscount;
	pDescription.append(spanApprove, spanDiscount);
	wrapper.classList.add('buy__form-promo');
	wrapper.append(input, pDescription);
	p.textContent = labels.promoError;

	return [label, wrapper, p];
}
function swapPromoCheckboxToInput (checkboxTrigger) {
	const parent = checkboxTrigger.parentElement;

	checkboxTrigger.remove();
	parent.append(...createPromoBlock());
}
function toggleCheckbox ({ triggerClass, toggleClass, checkedClass }) {


	return (e) => {
		const { target } = e
		const checkboxTrigger = target.closest('.' + triggerClass);

		if (!checkboxTrigger) {
			return;
		}

		const checkbox = checkboxTrigger.firstElementChild;
		const toggleElement = target.closest('.' + toggleClass);
		const { checked, name } = checkbox;

		if (!toggleElement) {
			return;
		}

		switch (name) {
			case 'isPromo':
				swapPromoCheckboxToInput(checkboxTrigger);

				break;
			case 'isSubscription':
				switchDateInputs(checked);

				break;
			case 'isTravelling':
				const startTariffId = '6';
				const tariffInput = document.getElementById('tariff');

				if (!tariffInput) {
					break;
				}

				const { value } = tariffInput.dataset;

				if (checked) {
					enableStartTariffButtons();
				} else {
					disableStartTariffButtons();
				}

				if (value !== startTariffId || checked) {
					break;
				}

				const tariffDefaults = {
					setInput:'tariff',
					text: defaults.tariff,
					value: defaults.tariff_id,
				}

				setInputValue(tariffDefaults, 'buy__form-tariff');

				break;
			default:
				break;
		}

		// if (name === 'isPromo') {
		// 	swapPromoCheckboxToInput(checkboxTrigger);
		// }

		if (checked) {
			removeClassFromElement(checkboxTrigger, checkedClass);
		} else {
			addClassToElement(checkboxTrigger, checkedClass);
		}

		checkbox.checked = !checked;
		updateBuyFormPrice();
		hideBuyInputError(e);
	}
}

function updateSelectedItem (listElements, value, selectedClass) {
	for (const listElement of listElements) {
		const { dataset } = listElement.firstElementChild;

		if (dataset.value === value) {
			addClassToElement(listElement, selectedClass);
		} else {
			removeClassFromElement(listElement, selectedClass);
		}
	}
}
function createSelectItem (itemClass, text, value) {
	const itemWrapper = document.createElement('div');
	const textSpan = document.createElement('span');
	const image = document.createElement('img');
	const button = document.createElement('button');

	image.src = '/img/modal-close.svg';
	image.setAttribute('alt', 'Remove territory');
	button.setAttribute(defaults.text_attribute_name, text);
	button.setAttribute(defaults.id_attribute_name, value);
	button.setAttribute('data-remove-territory', value);
	button.setAttribute('type', 'button');
	button.appendChild(image);
	textSpan.textContent = text;
	itemWrapper.classList.add(itemClass);
	itemWrapper.append(textSpan, button);

	return itemWrapper;
}
function updateSelectedTariff (value, selectedClass, modifier) {
	const tariffButtons = document.getElementsByClassName(selectedClass);

	for (const tariffButton of tariffButtons) {
		const { dataset } = tariffButton;

		if (dataset.value === value) {
			addClassToElement(tariffButton,selectedClass, modifier);
		} else {
			removeClassFromElement(tariffButton, selectedClass, modifier);
		}
	}
}
function setInputValue ({ setInput, text, value }, selectedClass = '') {
	const input = document.querySelector(`input[name="${setInput}"]`);

	if (!input) {
		return;
	}

	switch (setInput) {
		case 'territory':
		case 'type':
			input.value = text;
			input.setAttribute(defaults.id_attribute_name || 'data-value', value);

			const listElements = getListElements(input);

			updateSelectedItem(listElements, value, selectedClass);
			input.focus();
			input.blur();
			hideBuyInputError({ target: input });
			updateBuyFormPrice();
			buySelect.hideSelectList({ target: input });

			return;
		case 'tariff':
			if (value === '6') {
				const typesInput = document.querySelector('input[name="type"]');
				const excludeTypes = [ '3', '4' ];
				const typeDefaults = {
					setInput:'type',
					text: defaults.type,
					value: defaults.type_id,
				}

				disableOptions(typesInput.parentElement.lastElementChild.firstElementChild, ...excludeTypes);
				excludeTypes.includes(typesInput.dataset.value) && setInputValue(typeDefaults, 'buy__form-control--selected');
			} else {
				enableAllOptions();
			}

			input.value = text;
			input.setAttribute(defaults.id_attribute_name || 'data-value', value);
			updateBuyFormPrice();
			updateSelectedTariff(value, selectedClass, '--active');

			return;
		case 'insurer_email':
			const { hideAllLists } = buySelect;

			input.value = text;
			hideBuyInputError({ target: input });
			hideAllLists();

			return;
		// case 'territories':
		// 	const multiListElements = getListElements(input.parentElement);
		//
		// 	addMultiSelectListItem(input, 'buy__form-control--multiselect-list-item', text, value);
		// 	toggleSelectedItem(multiListElements, value, selectedClass);
		//
		// 	input.parentElement.scrollBy({
		// 		left: input.getBoundingClientRect().left,
		// 		behavior: 'smooth',
		// 	})
		//
		// 	return;
		default:
			return;
	}
}
function removeHiddenClassFromCollection (listCollection, hiddenClass) {
	for (const element of listCollection) {
		removeClassFromElement(element, hiddenClass);
	}
}
function filterSelect({ hiddenClass, activeClass, selectedClass }) {
	const removeHiddenClassFromCollection = (listCollection) => {
		for (const element of listCollection) {
			removeClassFromElement(element, hiddenClass);
		}
	}
	const autoSelect = (input, listCollection) => {
		let notHiddenItems = [];

		for (const element of listCollection) {
			if (!element.classList.contains(hiddenClass)) {
				notHiddenItems.push(element);
			}
		}

		if (notHiddenItems.length === 1) {
			const { dataset, textContent } = notHiddenItems[0].firstElementChild;

			updateSelectedItem(listCollection, dataset.value, selectedClass);
			input.focus();
			input.value = textContent;
			input.setAttribute(defaults.id_attribute_name || 'data-value', dataset.value);
			input.blur();
			removeHiddenClassFromCollection(listCollection);
			updateBuyFormPrice();
			buySelect.hideSelectList({ target: input });
		}
	};
	return (e) => {
		const { target, key } = e
		const { value } = target;
		const filteredKeys = [ 'Backspace', 'Delete' ];

		const listCollection = (getListElements(target));
		let notHiddenItemsCount = 0;

		for (const element of listCollection) {
			const { textContent } = element.firstElementChild;

			if (textContent.toLowerCase().includes(value.trim().toLowerCase())) {
				removeClassFromElement(element, hiddenClass);
				notHiddenItemsCount++;
			} else {
				addClassToElement(element, hiddenClass);
			}
		}

		if (!notHiddenItemsCount) {
			removeClassFromElement(target.parentElement, activeClass);
		} else {
			addClassToElement(target.parentElement, activeClass);
		}

		if (!filteredKeys.includes(key)) {
			debounce(autoSelect,  600)(target, listCollection);
		}
	}
}
function filterEmail({ hiddenClass, activeClass }) {
	const removeHiddenClassFromCollection = (listCollection) => {
		for (const element of listCollection) {
			removeClassFromElement(element, hiddenClass);
		}
	}

	return (e) => {
		const { target, key, keyCode } = e
		const { value } = target;
		const regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]*$/;
		const delimeterIndex = value.indexOf('@');
		const email = value.slice(0, delimeterIndex);
		const search = value.slice(delimeterIndex);
		const filteredKeys = [ 'Backspace', 'Delete' ];
		const excludeKeycodes = [38, 40, 13];
		let notHiddenItemsCount = 0;

		if (excludeKeycodes.includes(keyCode)) {
			return;
		}

		if (!regExp.test(value)) {
			removeClassFromElement(target.parentElement, activeClass);
			showAddTouristBtn();

			return;
		}

		const listCollection = getListElements(target);

		for (const element of listCollection) {
			const anchorElement = element.firstElementChild
			const { value } = anchorElement.dataset;

			anchorElement.textContent = email + value;
			anchorElement.setAttribute('data-text', email + value);

			if (value.startsWith(search.toLowerCase())) {
				removeClassFromElement(element, hiddenClass);
				notHiddenItemsCount++;
			} else {
				addClassToElement(element, hiddenClass);
			}
		}

		if (!notHiddenItemsCount) {
			removeClassFromElement(target.parentElement, activeClass);
			showAddTouristBtn();
		} else {
			addClassToElement(target.parentElement, activeClass);
			hideAddTouristBtn();
		}
	}
}
function filterMultiSelect({ hiddenClass, activeClass, selectedClass }) {
	// const autoSelect = (input, listCollection) => {
	// 	let notHiddenItems = [];
	//
	// 	for (const element of listCollection) {
	// 		if (!element.classList.contains(hiddenClass)) {
	// 			notHiddenItems.push(element);
	// 		}
	// 	}
	//
	// 	if (notHiddenItems.length === 1) {
	// 		const { dataset, textContent } = notHiddenItems[0].firstElementChild;
	//
	// 		updateSelectedItem(listCollection, dataset.value, selectedClass);
	// 		input.focus();
	// 		input.value = textContent;
	// 		input.setAttribute(defaults.id_attribute_name || 'data-value', dataset.value);
	// 		input.blur();
	// 		removeHiddenClassFromCollection(listCollection);
	// 		updateBuyFormPrice();
	// 		buySelect.hideSelectList({ target: input });
	// 	}
	// };
	return (e) => {
		const { target, key } = e
		const { value } = target;
		const filteredKeys = [ 'Backspace', 'Delete' ];
		const controlElement = target.closest('.buy__form-control--multiselect');

		const listCollection = controlElement.lastElementChild.firstElementChild.children;
		let notHiddenItemsCount = 0;

		for (const element of listCollection) {
			const { textContent } = element.firstElementChild;

			if (textContent.toLowerCase().includes(value.trim().toLowerCase())) {
				removeClassFromElement(element, hiddenClass);
				notHiddenItemsCount++;
			} else {
				addClassToElement(element, hiddenClass);
			}
		}
		//
		// if (!notHiddenItemsCount) {
		// 	removeClassFromElement(target.parentElement, activeClass);
		// } else {
		// 	addClassToElement(target.parentElement, activeClass);
		// }
		//
		// if (!filteredKeys.includes(key)) {
		// 	debounce(autoSelect,  600)(target, listCollection);
		// }
	}
}
function setStep ({ stepClass, tabClass, bodyClass }, button) {
	const modifier = '--active';
	const prevModifier  = '--prev';
	const setHeaderStep = (index) => {
		const tail = '/3';
		const headerSteps = Array.from(document.getElementsByClassName('buy__form-subheader-step'));

		if (!headerSteps.length) {
			return;
		}

		headerSteps.forEach(element => {
			const stepLabel = element.lastElementChild;

			stepLabel.textContent = ++index + tail;
		});
	}
	const setActiveState = (index, className) => {
		const elements = Array.from(document.getElementsByClassName(className));

		elements.forEach((element, idx) => {
			if (idx === index) {
				removeClassFromElement(element, className, prevModifier);
				addClassToElement(element, className, modifier);
			} else {
				removeClassFromElement(element, className, modifier);
			}
		})
	}
	const setPrevState = (index, className) => {
		if (index <= 0) {
			return;
		}

		const element = document.getElementsByClassName(className)[index - 1];

		addClassToElement(element, className, prevModifier);
	}

	return (index) => {
		setActiveState(index, stepClass);
		setActiveState(index, tabClass);
		setActiveState(index, bodyClass);
		setPrevState(index, bodyClass);
		setHeaderStep(index);

		if (index) {
			sendInfoGa(index + 1);
			// sendInfoGaOld(index + 1);
			sendInfoFba(index);
		}

		if (index === 2) {
			saveClientActivity(3);
		}
		// const activeBody = document.getElementsByClassName('buy__form-header')[0];
		//
		// if (activeBody) {
		// 	scrollToElement(activeBody, 1000);
		// }
	}
}
function showError ({ errorInputs }) {
	errorInputs.forEach(input => checkBuyInputValue({ target: input }));
}
function isBuyFormStepComplete(index, form) {
	let body = null;
	let isSubscription = false;
	let dateElementId = 'date';

	switch (index) {
		case '1':
			const fields = ['date', 'tariff', 'territory', 'isConfirmed', 'type'];

			body = validateForm(form, ...fields);
			isSubscription = body.isSubscription;

			if (isSubscription) {
				body.date = getFormatDates(body.subscription_date).join(defaults.date_separator);
				dateElementId = 'subscription_date';
			}

			if (!validateDateInput({ value: body.date })) {
				body.isValid = false;
				body.errorFields.push(dateElementId);
				body.errorInputs.push(document.getElementById(dateElementId));
			}

			body.countries = multiSelect.getSelectEntries()
				.map(([_, id]) => id);

			if (!multiSelect.validate()) {
				body.isValid = false;
				body.errorFields.push('territories');
				body.errorInputs.push(document.querySelector('input[name="territories"]'));
			}

			const { groupWrapper, validate } = multiSelect;

			if (!validate()) {
				addClassToElement(groupWrapper, 'buy__form-group', '--error');
			}

			if (body.isValid) {
				if (isMobile()) {
					scrollToElement(form, 400, 200);
				}

				// loadOnceItiLib(true);

				return true;
			}

			showError(body);

			return false;
		case '2':
			const countryEntries = multiSelect.getSelectEntries();

			body = validateForm(form);
			isSubscription = body.isSubscription;

			if (isSubscription) {
				body.date = getFormatDates(body.subscription_date).join(defaults.date_separator);
				dateElementId = 'subscription_date';
			}

			if (!validateDateInput({ value: body.date })) {
				body.isValid = false;
				body.errorFields.push(dateElementId);
				body.errorInputs.push(document.getElementById(dateElementId));
			}

			body.countries = countryEntries.map(([_, id]) => id);
			body.territory = countryEntries.map(([text]) => text).join(', ');

			if (!multiSelect.validate()) {
				body.isValid = false;
				body.errorFields.push('territories');
				body.errorInputs.push(document.querySelector('input[name="territories"]'));
			}

			if (body.isValid) {
				const { insurer, tourists, details } = groupUpBuyFormBody(body);

				addSummaryInfo(details, insurer, tourists);

				return true;
			}

			showError(body);

			return false;
		default:
			return true;
	}
}
function updateFormHeaderPriceView (wrapperBlock, { currency, price, discountPrice, isDiscount }) {
	const [priceSpan, currencySpan] = (new Array(3)).fill(0)
		.map(_ => document.createElement('span'));

	priceSpan.textContent = isDiscount ? discountPrice : price;
	currencySpan.textContent = currency;
	wrapperBlock.append(priceSpan, currencySpan);
}
function updateFormFooterPriceView (wrapperBlock, { currency, price, discountPrice, isDiscount }) {
	const nodes = [];
	const priceP = document.createElement('p')
	const [priceSpan, currencySpan] = (new Array(3)).fill(0)
		.map(_ => document.createElement('span'));

	priceSpan.textContent = isDiscount ? discountPrice : price;
	currencySpan.textContent = currency;
	priceP.append(priceSpan, currencySpan);
	nodes.push(priceP);

	if (isDiscount) {
		const totalPriceP = document.createElement('p')
		const [totalPriceSpan, totalCurrencySpan] = (new Array(3)).fill(0)
			.map(_ => document.createElement('span'));

		totalPriceSpan.textContent = price;
		totalCurrencySpan.textContent = currency;
		totalPriceP.append(totalPriceSpan, totalCurrencySpan);
		nodes.push(totalPriceP);
	}

	wrapperBlock.append(...nodes);
}
function updateFormFooterPriceViewNew (wrapperBlock, { currency, price, discountPrice, isDiscount, isPromo }) {
	const nodes = [];
	const priceP = document.createElement('p')
	const [priceSpan, currencySpan] = (new Array(3)).fill(0)
		.map(_ => document.createElement('span'));

	if (isDiscount && price != discountPrice) {
		const totalPriceP = document.createElement('p')
		const [totalPriceSpan, totalCurrencySpan] = (new Array(3)).fill(0)
			.map(_ => document.createElement('span'));

		totalPriceSpan.textContent = price;
		totalCurrencySpan.textContent = currency;
		totalPriceP.append(totalPriceSpan, totalCurrencySpan);
		nodes.push(totalPriceP);
	}

	priceSpan.textContent = isDiscount ? discountPrice : price;
	currencySpan.textContent = currency;
	priceP.append(priceSpan, currencySpan);

	if (isPromo) {
		const promoImg = document.createElement('img');

		promoImg.setAttribute('alt', 'Percent image');
		promoImg.src = '/img/icons/percent_dark.svg';
		priceP.appendChild(promoImg);
	}

	nodes.push(priceP);

	wrapperBlock.append(...nodes);

	if (isPromo) {
		addClassToElement(wrapperBlock, 'buy__form-prices', '--discount');
	} else {
		removeClassFromElement(wrapperBlock, 'buy__form-prices', '--discount');
	}
}
function setDiscountValue (value, type) {
	const key = type.toString()
	const types = {
		'1': 'USD',
		'2': '%',
	}

	if (!types[key]) {
		return value;
	}

	return value + types[key];
}
function updatePrice (form, onUpdateCb = ({ currency, price, discountPrice, isDiscount,  promo_code, valid_code }) => {}) {
	const isCorrectDate = (date) => {
		return /\d{4}-\d{2}-\d{2}/.test(date);
	}
	const scrollToBuyForm = runOnce(() => {
		scrollToElement(buyForm, 800);
	})
	let isFirstUpdate = true;

	return (e) => {
		// const fields = ['date', 'tariff', 'territory', 'type'];
		const { date_separator } = defaults;
		const fields = ['date', 'tariff', 'type'];
		const body = validateForm(form, ...fields);
		const { isSubscription, subscription_date } = body;
		const subscription_dates = getFormatDates(subscription_date).join(date_separator);
		let dateElementId = 'date';

		if (window.location.hash === '#form') {
			scrollToBuyForm();
		}

		if (isFirstUpdate) {
			const { date_start, date_end } = defaults;

			body.date = setDottedDateFormat(date_start) + date_separator + setDottedDateFormat(date_end);
		}

		if (isSubscription) {
			body.date = subscription_dates;
			dateElementId = 'subscription_date';
		}

		if (!validateDateInput({ value: body.date })) {
			body.isValid = false;
			body.errorFields.push(dateElementId);
			body.errorInputs.push(document.getElementById(dateElementId));
		}

		body.countries = multiSelect.getSelectEntries()
			.map(([_, id]) => id);

		if (!body.countries.length) {
			body.isValid = false;
			body.errorFields.push('territories');
			body.errorInputs.push(document.querySelector('input[name="territories"]'));
		}

		let { details, insurer, tourists } = groupUpBuyFormBody(body);

		if (body.isValid) {
			const isDiscount = timer.showCurrentTimestamp() > 0;
			const {
				date_from, date_to, countries, program_id,
				already_traveling, promo_code, travel_type, is_subscription
			} = normalizeDetails(details);
			const paramsPromo = getPromoFromURLParams();
			const isNeedSetPromo = isFirstUpdate && paramsPromo;

			insurer = normalizePerson(insurer);
			tourists = tourists.map(normalizePerson);

			if (!tourists.length) {
				tourists.push(insurer);
			}

			if (isNeedSetPromo) {
				const checkboxTrigger = document
					.querySelector('.buy__form-control--checkbox > input[name="isPromo"]').parentElement;

				swapPromoCheckboxToInput(checkboxTrigger);

				const promoCodeInputs = Array.from(document.querySelectorAll('input[name="promo"]'));

				if (promoCodeInputs.length) {
					promoCodeInputs.forEach(input => input.value = paramsPromo);
					// scrollToElement(promoCodeInputs[0].form, 800);
					scrollToBuyForm();
				}
			}

			isFirstUpdate = false;

			sendRequestAndSaveToken('/api/get_policy_price', {
				method: 'POST',
				headers: {
					"Content-Type": "application/json"
				},
				body: JSON.stringify({
					date_from,
					date_to,
					countries,
					program_id,
					already_traveling,
					promo_code: isNeedSetPromo ? paramsPromo : promo_code,
					travel_type,
					particular_tourists: tourists.map(({ date_birth }) => {
						return  { date_birth: isCorrectDate(date_birth) ? date_birth : defaults.adult_birthday };
					}),
					additional_services: [],
					is_subscription,
					year_program: false,
					discount_available: isDiscount,
				})
			}).then(({response}) => {
				if (!response || !response.success) {
					return;
				}

				const {
					currency, tariff_id, tariff_name, original_amount,
					total_amount, valid_code, code_type, code_value, esim_info
				} = response.data[0];
				// const discountPrice = (total_amount * discountMultiplier).toFixed(2);
				const price = isDiscount ? original_amount.toFixed(2) : total_amount;

				localStorage.setItem('price', total_amount);
				// onUpdateCb({ currency, price: total_amount, discountPrice, isDiscount,  promo_code, valid_code });
				onUpdateCb({
					currency,
					price,
					discountPrice: total_amount,
					isDiscount,
					promo_code: isNeedSetPromo ? paramsPromo : promo_code,
					valid_code,
					code_type,
					code_value,
					esim_info,
				});
			});
		} else {
			onUpdateCb({ price: 0 });
		}

	}
}
function getTime (timestamp) {
	const millisecond = 10;
	const second = 100 * millisecond;
	const minute = 60 * second;
	const hour = 60 * minute;
	const day = 24 * hour;

	return [
		// timestamp / day,							// days
		(timestamp % day) / hour,					// hours
		(timestamp % hour) / minute,				// minutes
		(timestamp % minute) / second,              // seconds
		// (timestamp % second) / millisecond       // milliseconds
	].map((n, idx) => {
		n = Math.floor(n);
		return n < 10 && idx ? `0${n}` : n;
	}).join(':');
}
function createTimerViewHandler ({ labelClass, progressClass, millisecondsClass, timerType }) {
	const timeDelimeter = 15 * 60 * 1000;
	let lastDelimeter = undefined;
	const getPercent = (timestamp, timestampLimit) => {
		return timestamp / timestampLimit * 100;
	}
	const getLabelElement = (className) => {
		return document.getElementsByClassName(className)[0].firstElementChild
	}
	const getCircleProgressLength = (element) => {
		return element.getAttribute('stroke-dasharray').split(' ')[1] || 0;
	}
	const getCircleProgressBarElement = (className) => {
		return document.querySelector('.' + className + '>svg>circle');
	}
	const getLinearProgressBarElement = (className) => {
		return document.getElementsByClassName(className)[0];
	}
	const setLabelText = (element, text) => {
		if (element) {
			element.textContent = text;
		}
	}
	const setCircleZeroProgressColor = (element) =>  {
		const color = element.previousElementSibling?.getAttribute('fill');

		if (color) {
			element.setAttribute('stroke', color);
		}
	};
	const setCircleProgressWidth = (element, percent, progressLength) => {
		if (element && percent >= 0 && progressLength >= 0) {
			const dasharray = `${progressLength * percent / 100} ${progressLength}`;

			element.setAttribute('stroke-dasharray', dasharray);
		}
	}
	const setLinearProgressWidth = (element, percent) => {
		if (element && percent >= 0) {
			element.style.width = `${percent}%`;
		}
	}
	const labelElement = getLabelElement(labelClass);
	const progressElement = timerType === 'circle' ? getCircleProgressBarElement(progressClass)
		: getLinearProgressBarElement(progressClass);
	const progressLength = timerType === 'circle' ? getCircleProgressLength(progressElement) : null;
	return {
		update: (timestamp, timestampLimit) => {
			// const percent = getPercent(timestamp, timestampLimit);
			const time = getTime(timestamp < 0 ? 0 : timestamp);
			const delimeter = lastDelimeter || timeDelimeter;

			// if (timestamp < timeDelimeter && !lastDelimeter) {
			// 	lastDelimeter = timestamp;
			// }

			const percent = getPercent(timestamp % delimeter, delimeter);

			setLabelText(labelElement, time);
			addClassToElement(labelElement.parentElement, millisecondsClass);

			if (timerType === 'circle') {
				setCircleProgressWidth(progressElement, percent, progressLength);
			} else {
				setLinearProgressWidth(progressElement, percent);
			}

			if (timestamp < 0) {
				removeClassFromElement(labelElement.parentElement, millisecondsClass);

				if (timerType === 'circle') {
					setCircleZeroProgressColor(progressElement);
				}
			}
		}
	}
}
function createTimer (timestampStorageKey, discountTimestamp, timestampLimit, timerTickStep, onTickCb = (timestamp, timestampLimit) => {}, onEndCb = () => {}) {
	const getDiscountTimestamp = (timestampLimit) => {
		// const timestamp = localStorage.getItem(timestampStorageKey);  // 'discountTimestamp'
		//
		// if (timestamp && timestamp <= timestampLimit) {
		// 	return  timestamp;
		// }

		localStorage.setItem(timestampStorageKey, timestampLimit);

		return timestampLimit;
	}
	const setDiscountTimestamp = (timestamp) => {
		localStorage.setItem('discountTimestamp', timestamp);
	}
	const showCurrentTimestamp = () => {
		return timestamp;
	}
	// let timestamp = getDiscountTimestamp(timestampLimit);
	let timestamp = discountTimestamp;
	const timerInterval = setInterval(() => {
		// setDiscountTimestamp(timestamp);

		if (timestamp <= 0) {
			timestamp = 0;
			clearInterval(timerInterval);
			onEndCb();
		}

		onTickCb(timestamp - timerTickStep, timestampLimit);

		timestamp -= timerTickStep;
	}, timerTickStep);

	return { showCurrentTimestamp };
}
function groupUpBuyFormBody (body) {
	const insurer = {};
	const tourists = [];
	const details = {};

	for (const field in body) {
		const value = body[field];
		const [typeName, fieldName, id] = field.split('_');

		if (!fieldName || fieldName === 'id') {
			details[field] = value;
		}
		if (typeName === 'insurer') {
			insurer[fieldName] = value;
		}
		if (typeName === 'tourist') {
			const tourist = tourists.find(tourist => tourist.id === id)

			if (tourist) {
				tourist[fieldName] = value;
			} else {
				tourists.push({ id, [fieldName]: value })
			}
		}
	}

	return { insurer, tourists, details };
}

function updateWrapperStyles () {
	const firstModifier = '--first';
	const lastModifier = '--last';
	const { wrapperClass } = classes;
	const secondStepFormBody = document.getElementsByClassName('buy__form-body')[1];
	const indexesBlocksCollection = Array.from(secondStepFormBody.getElementsByClassName(wrapperClass)).reverse();

	indexesBlocksCollection.forEach((block, index, collection) => {
		if (collection.length > 1 && index === collection.length - 1) {
			addClassToElement(block, wrapperClass, firstModifier);
		} else {
			removeClassFromElement(block, wrapperClass, firstModifier);
		}


		if (index) {
			removeClassFromElement(block, wrapperClass, lastModifier);
		} else {
			addClassToElement(block, wrapperClass, lastModifier)
		}
	})
}
function updateTourists ({ tourist, id }, button) {
	const createAside = (index) => {
		const aside = document.createElement('div');
		const description = document.createElement('p');
		const title = document.createElement('h6');
		const titleLabel = document.createElement('span');
		const titleSubLabel = document.createElement('span');

		titleLabel.textContent = labels.title;
		titleSubLabel.textContent = '#' + index;
		title.append(titleLabel, titleSubLabel);
		description.textContent = labels.description;
		aside.append(title, description);
		aside.classList.add(classes.touristClass);

		return aside;
	}
	const createDateGroup = (id, key, labelText, placeholder = '', value = '') => {
		const label = document.createElement('label');
		const input = document.createElement('input');
		const error = document.createElement('p');
		const date = document.createElement('div');
		const group = document.createElement('div');
		const pPlaceholder = document.createElement('p');
		const name = `${key}_${id}`;

		label.setAttribute('for', name);
		label.textContent = labelText;
		input.setAttribute('type', 'text');
		input.setAttribute('name', name);
		// input.setAttribute('placeholder', placeholder);
		input.dataset['id'] = id;
		input.value = value;
		// date.classList.add(classes.dateClass, 'date');
		date.classList.add(classes.dateClass, classes.dateClass + '--no-icon', 'date');
		pPlaceholder.innerHTML = !value ? placeholder : `<span>${value}</span>` + placeholder.slice(value.length);
		date.append(input, pPlaceholder);
		error.textContent = labels.birthdayError;
		error.classList.add(classes.errorClass);
		group.append(label, date, error);
		group.classList.add(classes.groupClass);

		return group;
	}
	const createTextGroup = (id, key, labelText, placeholder = '', value = '') => {
		const label = document.createElement('label');
		const input = document.createElement('input');
		const error = document.createElement('p');
		const group = document.createElement('div');
		const name = `${key}_${id}`;

		label.setAttribute('for', name);
		label.textContent = labelText;
		input.setAttribute('type', 'text');
		input.setAttribute('name', name);
		input.setAttribute('placeholder', placeholder);
		input.setAttribute('data-error-required', labels[`${key.split('_')[1]}ErrorEmpty`] || '');
		input.setAttribute('data-error', labels[`${key.split('_')[1]}Error`]);
		input.dataset['id'] = id;
		input.value = value;
		error.textContent = labels[`${key.split('_')[1]}Error`];
		error.classList.add(classes.errorClass);
		group.append(label, input, error);
		group.classList.add(classes.groupClass);

		return group;
	}
	const createTouristBlockOld = (tourist = {name: '', lastname: '', passport: '', birthday: '', id: ''}, tourists) => {
		const id = tourist.id || '';
		const index = tourists.length;
		const wrapper = document.createElement('div');
		const content = document.createElement('div');
		const aside = createAside(index);
		const name = createTextGroup(id, 'tourist_name', labels.nameLabel, labels.namePlaceholder, tourist.name);
		const lastname = createTextGroup(id, 'tourist_lastname', labels.surnameLabel, labels.surnamePlaceholder, tourist.lastname);
		const passport = createTextGroup(id, 'tourist_passport', labels.passportLabel, labels.passportPlaceholder, tourist.passport);
		const birthday = createDateGroup(id, 'tourist_birthday', labels.birthdayLabel, labels.birthdayPlaceholder, tourist.birthday);

		content.append(name, lastname, passport, birthday);
		content.classList.add(classes.contentClass);
		wrapper.append(aside, content);
		wrapper.classList.add(classes.wrapperClass);

		return wrapper;
	}
	const createTouristBlock = (tourist = {name: '', lastname: '', passport: '', birthday: '', id: ''}, tourists) => {
		const id = tourist.id || '';
		const index = tourists.length;
		const wrapper = document.createElement('div');
		const content = document.createElement('div');
		const buttons = document.createElement('div');
		const line = document.createElement('div');
		const aside = createAside(index);
		const name = createTextGroup(id, 'tourist_name', labels.nameLabel, labels.namePlaceholder, tourist.name);
		const lastname = createTextGroup(id, 'tourist_lastname', labels.surnameLabel, labels.surnamePlaceholder, tourist.lastname);
		const passport = createTextGroup(id, 'tourist_passport', labels.passportLabel, labels.passportPlaceholder, tourist.passport);
		const birthday = createDateGroup(id, 'tourist_birthday', labels.birthdayLabel, labels.birthdayPlaceholder, tourist.birthday);
		const trashImg = document.createElement('img');
		const removeSpan = document.createElement('span');
		const removeBtn = document.createElement('button');
		const plusImg = document.createElement('img');
		const addSpan = document.createElement('span');
		const addBtn = document.createElement('button');

		trashImg.src = images.trash;
		trashImg.setAttribute('alt', 'Trash icon');
		removeSpan.textContent = labels.removeBtnLabel;
		removeBtn.setAttribute('type', 'button');
		removeBtn.dataset['tourist'] = 'remove';
		removeBtn.dataset['id'] = id;
		removeBtn.append(trashImg, removeSpan);
		plusImg.src = images.plus;
		plusImg.setAttribute('alt', 'Plus icon');
		addSpan.textContent = labels.addBtnLabel;
		addBtn.setAttribute('type', 'button');
		addBtn.dataset['tourist'] = 'add';
		addBtn.append(plusImg, addSpan);

		content.append(name, lastname, passport, birthday);
		content.classList.add(classes.contentClass);
		buttons.append(removeBtn, addBtn);
		buttons.classList.add(classes.contentClass + '-buttons');
		wrapper.append(aside, content, buttons);
		wrapper.classList.add(classes.wrapperClass);

		return wrapper;
	}
	// const createTouristBlockNew = (tourist = {name: '', lastname: '', passport: '', birthday: '', id: ''}, tourists) => {
	// 	const id = tourist.id || '';
	// 	const index = tourists.length;
	// 	const wrapper = document.createElement('div');
	// 	const content = document.createElement('div');
	// 	const aside = createAside(index);
	// 	const name = createTextGroup(id, 'tourist_name', labels.nameLabel, labels.namePlaceholder, tourist.name);
	// 	const lastname = createTextGroup(id, 'tourist_lastname', labels.surnameLabel, labels.surnamePlaceholder, tourist.lastname);
	// 	const passport = createTextGroup(id, 'tourist_passport', labels.passportLabel, labels.passportPlaceholder, tourist.passport);
	// 	const birthday = createDateGroup(id, 'tourist_birthday', labels.birthdayLabel, labels.birthdayPlaceholder, tourist.birthday);
	// 	const trashImg = document.createElement('img');
	// 	const removeSpan = document.createElement('span');
	// 	const removeBtn = document.createElement('button');
	//
	// 	trashImg.src = images.trash;
	// 	trashImg.setAttribute('alt', 'Trash icon');
	// 	removeSpan.textContent = labels.removeBtnLabel;
	// 	removeBtn.setAttribute('type', 'button');
	// 	removeBtn.dataset['tourist'] = 'remove';
	// 	removeBtn.dataset['id'] = id;
	// 	removeBtn.classList.add('buy__form-wrapper-button');
	// 	removeBtn.append(trashImg, removeSpan);
	// 	content.append(name, lastname, passport, birthday, removeBtn);
	// 	content.classList.add(classes.contentClass);
	// 	wrapper.append(aside, content);
	// 	wrapper.classList.add(classes.wrapperClass);
	// 	wrapper.classList.add(classes.wrapperClass + '-tourist');
	//
	// 	if (index) {
	// 		wrapper.classList.add(classes.wrapperClass + '--card-appear');
	// 	}
	// 	// wrapper.classList.add(classes.wrapperClass + '--accordion-scale');
	// 	// wrapper.classList.add(classes.wrapperClass + '--card-appear');
	// 	// wrapper.classList.add(classes.wrapperClass + '--show');
	//
	// 	return wrapper;
	// }
	const createAdditionBlock = (id) => {
		const addition = document.createElement('div');
		const trashImg = document.createElement('img');
		const removeSpan = document.createElement('span');
		const removeBtn = document.createElement('button');
		const plusImg = document.createElement('img');
		const addSpan = document.createElement('span');
		const addBtn = document.createElement('button');

		trashImg.src = images.trash;
		trashImg.setAttribute('alt', 'Trash icon');
		removeSpan.textContent = labels.removeBtnLabel;
		removeBtn.setAttribute('type', 'button');
		removeBtn.dataset['tourist'] = 'remove';
		removeBtn.dataset['id'] = id;
		removeBtn.append(trashImg, removeSpan);
		plusImg.src = images.plus;
		plusImg.setAttribute('alt', 'Plus icon');
		addSpan.textContent = labels.addBtnLabel;
		addBtn.setAttribute('type', 'button');
		addBtn.dataset['tourist'] = 'add';
		addBtn.append(plusImg, addSpan);
		addition.append(removeBtn, addBtn);
		addition.classList.add(classes.additionClass);

		return addition;
	}
	const addNewTourist = (button, insurer, tourists) => {
		const parent = button.parentElement;
		const id = Date.now().toString(16);
		const touristObj = {
			id,
			name: '',
			lastname: '',
			passport: '',
			birthday: '',
		};

		if (parent.classList.contains(classes.shortClass)) {
			parent.remove();
		}

		if (!tourists.length) {
			for (const key in touristObj) {
				if (insurer[key]) {
					touristObj[key] = insurer[key];
				}
			}
		}

		const body = document.getElementsByClassName(classes.activeBodyClass)[0];
		const footer = body.lastElementChild;
		const tourist = createTouristBlock(touristObj, tourists);
		const addition = createAdditionBlock(id);
		let firstInput = null;
		let speed = tourists.length ? 200 : 400;

		body.insertBefore(tourist, footer);
		// body.insertBefore(addition, footer);
		Array.from(body.getElementsByTagName('input'))
			.filter(input => input.dataset['id'] === id)
			.forEach((input, idx) => {
				const [ _, fieldName ] = input.name.split('_');
				const selector = `input[name="${input.name}"]`;

				savePlaceholder(input);
				input.addEventListener('focus', hidePlaceholder);
				input.addEventListener('focus', hideBuyInputError);
				input.addEventListener('blur', showPlaceholder);
				input.addEventListener('blur', checkBuyInputValue);
				input.addEventListener('input', modifyValueToUpperCase);

				if (fieldName === 'birthday') {
					// input.addEventListener('keyup', dateInputMask);
					input.addEventListener('keyup', maskInputAndSetMaskedDate);
					input.addEventListener('blur', updateBuyFormPrice);
				}

				if(!idx) {
					firstInput = input;
				}

				if (tourists.length) {
					return;
				}

				if (fieldName === 'name') {
					syncNameInputs.add(selector);
					input.addEventListener('keyup', syncNameInputs.listener);
				}

				if (fieldName === 'lastname') {
					syncLastNameInputs.add(selector);
					input.addEventListener('keyup', syncLastNameInputs.listener);
				}

				if (fieldName === 'passport') {
					syncPassportInputs.add(selector);
					input.addEventListener('keyup', syncPassportInputs.listener);
				}

				if (fieldName === 'birthday') {
					syncBirthdayInputs.add(selector);
					input.addEventListener('keyup', syncBirthdayInputs.listener);
				}
			});
		updateTouristIndexes();
		// updateAddButtonStyle();
		updateWrapperStyles();
		// firstInput.focus();
		// scrollToInputAndFocus(firstInput);

		if (tourists.length) {
			// tourist.classList.add(classes.wrapperClass + '--card-appear');
			tourist.classList.add(classes.wrapperClass + '--show');

			scrollToInputAndFocusAdvanced(firstInput)

			// scrollToElementPromisified(tourist, speed).then(() => {
			// 	firstInput.focus();
			// });
		}


		// scrollToInputAndFocusAdvanced(firstInput, {
		// 	speed: 100,
		// 	selectAll: true
		// })
	}
	// const addNewTouristUpdated = (button, insurer, tourists) => {
	// 	// const parent = button.parentElement;
	// 	const id = Date.now().toString(16);
	// 	const touristObj = {
	// 		id,
	// 		name: '',
	// 		lastname: '',
	// 		passport: '',
	// 		birthday: '',
	// 	};
	//
	// 	// if (parent.classList.contains(classes.shortClass)) {
	// 	// 	parent.remove();
	// 	// }
	//
	// 	if (!tourists.length) {
	// 		for (const key in touristObj) {
	// 			if (insurer[key]) {
	// 				touristObj[key] = insurer[key];
	// 			}
	// 		}
	// 	}
	//
	// 	const body = document.getElementsByClassName(classes.activeBodyClass)[0];
	// 	const footer = body.lastElementChild;
	// 	const tourist = createTouristBlockNew(touristObj, tourists);
	// 	// const addition = createAdditionBlock(id);
	// 	let firstInput = null;
	//
	// 	body.insertBefore(tourist, footer);
	// 	// body.insertBefore(addition, footer);
	// 	Array.from(body.getElementsByTagName('input'))
	// 		.filter(input => input.dataset['id'] === id)
	// 		.forEach((input, idx) => {
	// 			const [ _, fieldName ] = input.name.split('_');
	// 			const selector = `input[name="${input.name}"]`;
	//
	// 			savePlaceholder(input);
	// 			input.addEventListener('focus', hidePlaceholder);
	// 			input.addEventListener('focus', hideBuyInputError);
	// 			input.addEventListener('blur', showPlaceholder);
	// 			input.addEventListener('blur', checkBuyInputValue);
	// 			input.addEventListener('input', modifyValueToUpperCase);
	//
	// 			if (fieldName === 'birthday') {
	// 				// input.addEventListener('keyup', dateInputMask);
	// 				input.addEventListener('keyup', maskInputAndSetMaskedDate);
	// 				input.addEventListener('blur', updateBuyFormPrice);
	// 			}
	//
	// 			if(!idx) {
	// 				firstInput = input;
	// 			}
	//
	// 			if (tourists.length) {
	// 				return;
	// 			}
	//
	// 			if (fieldName === 'name') {
	// 				syncNameInputs.add(selector);
	// 				input.addEventListener('keyup', syncNameInputs.listener);
	// 			}
	//
	// 			if (fieldName === 'lastname') {
	// 				syncLastNameInputs.add(selector);
	// 				input.addEventListener('keyup', syncLastNameInputs.listener);
	// 			}
	//
	// 			if (fieldName === 'passport') {
	// 				syncPassportInputs.add(selector);
	// 				input.addEventListener('keyup', syncPassportInputs.listener);
	// 			}
	//
	// 			if (fieldName === 'birthday') {
	// 				syncBirthdayInputs.add(selector);
	// 				input.addEventListener('keyup', syncBirthdayInputs.listener);
	// 			}
	// 		});
	// 	updateTouristIndexes();
	// 	// updateAddButtonStyle();
	// 	firstInput.focus();
	// 	// scrollToInputAndFocus(firstInput);
	// 	// scrollToInputAndFocusAdvanced(firstInput, {
	// 	// 	speed: 400,
	// 	// 	selectAll: true
	// 	// })
	// }
	const removeCurrentTourist = (button, tourists) => {
		const { dataset } = button;
		const body = document.getElementsByClassName(classes.activeBodyClass)[0];
		// const addition = button.parentElement;
		// const tourist = addition.previousElementSibling;
		const tourist = button.parentElement.parentElement;

		Array.from(body.getElementsByTagName('input'))
			.filter(input => input.dataset['id'] === dataset['id'])
			.forEach(input => {
				const [ _, fieldName ] = input.name.split('_');
				const selector = `input[name="${input.name}"]`;

				input.removeEventListener('focus', hidePlaceholder);
				input.removeEventListener('focus', hideBuyInputError);
				input.removeEventListener('blur', showPlaceholder);
				input.removeEventListener('blur', checkBuyInputValue);
				input.removeEventListener('input', modifyValueToUpperCase);

				if (fieldName === 'birthday') {
					// input.removeEventListener('keyup', dateInputMask);
					input.removeEventListener('keyup', maskInputAndSetMaskedDate);
					input.removeEventListener('blur', updateBuyFormPrice);
				}

				if (syncNameInputs.exists(selector)) {
					input.removeEventListener('keyup', syncNameInputs.listener);
				}
				if (syncLastNameInputs.exists(selector)) {
					input.removeEventListener('keyup', syncLastNameInputs.listener);
				}
				if (syncPassportInputs.exists(selector)) {
					input.removeEventListener('keyup', syncPassportInputs.listener);
				}
				if (syncBirthdayInputs.exists(selector)) {
					input.removeEventListener('keyup', syncBirthdayInputs.listener);
				}
			});

		tourist.classList.add(classes.wrapperClass + '--hide');
		scrollUpByElementHeight(tourist, 400).then(() => {
			tourist.remove();
			updateTouristIndexes();
			// updateAddButtonStyle();
			updateWrapperStyles();
			updateBuyFormPrice();
		});



		// tourist.remove();
		// updateTouristIndexes();
		// updateAddButtonStyle();
		// tourist.classList.add(classes.wrapperClass + '--hide');
		// addition.classList.add(classes.additionClass + '--hide');
		// if (tourists.length === 1) {
		// 	addition.classList.remove(classes.additionClass + '--hide');
		// 	addition.classList.add(classes.shortClass);
		// } else {
		// 	addition.remove();
		// }




		// scrollToElement(tourist.previousElementSibling, 400);
		// setTimeout(() => {
		// 	tourist.remove();
		// 	updateTouristIndexes();
		// 	updateAddButtonStyle();
		// }, 0.2 * 1000);
		// reduceElementHeight(tourist, 350).then(() => {
		// 	tourist.remove();
		// 	updateTouristIndexes();
		// 	updateAddButtonStyle();
		// })

	}
	const removeCurrentTouristUpdated = (button, tourists) => {
		const { dataset } = button;
		const body = document.getElementsByClassName(classes.activeBodyClass)[0];
		const tourist = button.closest('.' + classes.wrapperClass);

		Array.from(body.getElementsByTagName('input'))
			.filter(input => input.dataset['id'] === dataset['id'])
			.forEach(input => {
				const [ _, fieldName ] = input.name.split('_');
				const selector = `input[name="${input.name}"]`;

				input.removeEventListener('focus', hidePlaceholder);
				input.removeEventListener('focus', hideBuyInputError);
				input.removeEventListener('blur', showPlaceholder);
				input.removeEventListener('blur', checkBuyInputValue);
				input.removeEventListener('input', modifyValueToUpperCase);

				if (fieldName === 'birthday') {
					// input.removeEventListener('keyup', dateInputMask);
					input.removeEventListener('keyup', maskInputAndSetMaskedDate);
					input.removeEventListener('blur', updateBuyFormPrice);
				}

				if (syncNameInputs.exists(selector)) {
					input.removeEventListener('keyup', syncNameInputs.listener);
				}
				if (syncLastNameInputs.exists(selector)) {
					input.removeEventListener('keyup', syncLastNameInputs.listener);
				}
				if (syncPassportInputs.exists(selector)) {
					input.removeEventListener('keyup', syncPassportInputs.listener);
				}
				if (syncBirthdayInputs.exists(selector)) {
					input.removeEventListener('keyup', syncBirthdayInputs.listener);
				}
			});

		tourist.classList.remove(classes.wrapperClass + '--card-appear');
		tourist.classList.add(classes.wrapperClass + '--card-collapse');
		reduceElementHeight(tourist, 200).then(() => {
			tourist.remove();
			updateTouristIndexes();
			updateBuyFormPrice();
		})

	}
	const updateTouristIndexes = () => {
		const indexesBlocksCollection = document.getElementsByClassName(classes.touristClass);
		let index = 1;

		for (const block of indexesBlocksCollection) {
			const indexElement = block.firstElementChild.lastElementChild

			indexElement.textContent = `#${index}`;
			index++;
		}
	}
	const updateAddButtonStyle = () => {
		const lastModifier = '--last';
		const { additionClass } = classes;
		const indexesBlocksCollection = Array.from(document.getElementsByClassName(additionClass)).reverse();

		indexesBlocksCollection.forEach((block, index) => {
			if (index) {
				removeClassFromElement(block, additionClass, lastModifier);
			} else {
				addClassToElement(block, additionClass, lastModifier)
			}
		})
	}

	const body = validateForm(button.form);
	const { insurer, tourists } = groupUpBuyFormBody(body);

	switch (tourist) {
		case 'add':
			if (!body.isValid) {
				showError(body);

				return;
			}

			addNewTourist(button, insurer, tourists);
			// addNewTouristUpdated(button, insurer, tourists);

			if (!tourists.length) {
				addNewTourist(button, insurer, [{}]);
				// addNewTouristUpdated(button, insurer, [{}]);
			}

			break;
		case 'remove':
			removeCurrentTourist(button, tourists);
			// removeCurrentTouristUpdated(button, tourists);
			break;
		case 'removeAll':
			const buttons = Array.from(document.querySelectorAll('button[data-tourist="remove"]'));

			buttons.forEach(button => removeCurrentTourist(button, tourists));

			break;
		default:
			return;
	}
}
function addSummaryInfo (details, insurer, tourists) {
	const createDetailsTable = (details) => {
		const table = document.createElement('table');
		const tbody = document.createElement('tbody');
		const [trTariff, trDates, trCountry] = (new Array(3)).fill(0)
			.map(_ => document.createElement('tr'));
		const [tdTariffLabel, tdTariff, tdDatesLabel, tdDates, tdCountryLabel, tdCountry] = (new Array(6)).fill(0)
			.map(_ => document.createElement('td'));

		tdTariffLabel.textContent = labels.tariffLabel;
		tdTariff.textContent = details.tariff;
		trTariff.append(tdTariffLabel, tdTariff);
		tdDatesLabel.textContent = labels.datesLabel;
		tdDates.textContent = details.date;
		trDates.append(tdDatesLabel, tdDates);
		tdCountryLabel.textContent = labels.countryLabel;
		tdCountry.textContent = details.territory;
		trCountry.append(tdCountryLabel, tdCountry);
		tbody.append(trTariff, trDates, trCountry);
		table.append(tbody);
		table.classList.add(classes.tableClass);

		return table;
	}
	const createInsurerTable = (insurer) => {
		const table = document.createElement('table');
		const tbody = document.createElement('tbody');
		const [trBuyer, trFullName, trBirthday, trPassport, trEmail, trPhone,] = (new Array(6)).fill(0).map(_ => document.createElement('tr'));
		const [tdBuyerLabel, tdBuyer, tdFullNameLabel, tdFullName, tdBirthdayLabel, tdBirthday, tdPassportLabel, tdPassport, tdEmailLabel, tdEmail, tdPhoneLabel, tdPhone,] = (new Array(12)).fill(0).map(_ => document.createElement('td'));

		tdBuyerLabel.textContent = labels.buyerLabel;
		trBuyer.append(tdBuyerLabel, tdBuyer);
		tdFullNameLabel.textContent = labels.fullNameLabel;
		tdFullName.textContent = insurer.name + ' ' + insurer.lastname;
		trFullName.append(tdFullNameLabel, tdFullName);
		tdBirthdayLabel.textContent = labels.birthdayLabel;
		tdBirthday.textContent = insurer.birthday;
		trBirthday.append(tdBirthdayLabel, tdBirthday);
		tdPassportLabel.textContent = labels.passportLabel;
		tdPassport.textContent = insurer.passport;
		trPassport.append(tdPassportLabel, tdPassport);
		tdEmailLabel.textContent = labels.emailLabel;
		tdEmail.textContent = insurer.email;
		trEmail.append(tdEmailLabel, tdEmail);
		tdPhoneLabel.textContent = labels.phoneLabel;
		tdPhone.textContent = insurer.phone;
		trPhone.append(tdPhoneLabel, tdPhone);
		tbody.append(trBuyer, trFullName, trBirthday, trPassport, trEmail, trPhone);
		table.append(tbody);
		table.classList.add(classes.tableClass);
		table.classList.add(`${classes.tableClass}--violet`);

		return table;
	}
	const createTouristTable = (tourist, index) => {
		const table = document.createElement('table');
		const tbody = document.createElement('tbody');
		const [trParticipant, trFullName, trBirthday, trPassport,] = (new Array(6)).fill(0).map(_ => document.createElement('tr'));
		const [tdParticipantLabel, tdParticipant, tdFullNameLabel, tdFullName, tdBirthdayLabel, tdBirthday, tdPassportLabel, tdPassport,] = (new Array(12)).fill(0).map(_ => document.createElement('td'));

		tdParticipantLabel.textContent = labels.participantLabel + (index + 1);
		trParticipant.append(tdParticipantLabel, tdParticipant);
		tdFullNameLabel.textContent = labels.fullNameLabel;
		tdFullName.textContent = tourist.name + ' ' + tourist.lastname;
		trFullName.append(tdFullNameLabel, tdFullName);
		tdBirthdayLabel.textContent = labels.birthdayLabel;
		tdBirthday.textContent = tourist.birthday;
		trBirthday.append(tdBirthdayLabel, tdBirthday);
		tdPassportLabel.textContent = labels.passportLabel;
		tdPassport.textContent = tourist.passport;
		trPassport.append(tdPassportLabel, tdPassport);
		tbody.append(trParticipant, trFullName, trBirthday, trPassport);
		table.append(tbody);
		table.classList.add(classes.tableClass);
		table.classList.add(`${classes.tableClass}--violet`);

		return table;
	}
	const wrapper = document.getElementsByClassName(classes.detailsClass)[0];
	const length = tourists.length;
	const touristsTables = [];

	wrapper.innerHTML = '';
	wrapper.append(createDetailsTable(details), createInsurerTable(insurer));

	if (!length) {
		return;
	}

	for (let idx = 0; idx < length; idx++) {
		touristsTables.push(createTouristTable(tourists[idx], idx));
	}

	wrapper.append(...touristsTables);
}
function getFormDefaults () {
	const getAdultBirthday = (date, adultYearsCount) => {
		return [
			date.getFullYear() - adultYearsCount,
			date.getMonth() + 1,
			date.getDate(),
		].map(n => n < 10 ? `0${n}` : n).join('-');
	}
	const timestamp = Date.now();
	const adultYearsCount = 21;
	const day = 24 * 60 * 60 * 1000;
	const date_start = new Date(timestamp + day - day);
	const date_end = new Date(timestamp + 7 * day - day);
	const max_date = new Date(timestamp + 366 * day);
	const date_separator = ' - ';
	const human_date_start = dateToHumanFormat(date_start, true);
	const human_date_end = dateToHumanFormat(date_end, true);

	return {
		text_attribute_name: 'data-text',
		id_attribute_name: 'data-value',
		calendar_close_attribute_name: 'data-hide-calendar',
		tariff_id: '11',
		tariff: 'Gold',
		territory_id: '207',
		territory: 'Worldwide',
		type_id: '1',
		type: labels.defaultRestType,
		date:  human_date_start + date_separator + human_date_end,
		date_separator,
		date_start,
		date_end,
		max_date,
		human_date_start,
		human_date_end,
		adult_birthday: getAdultBirthday(date_start, adultYearsCount),
		isConfirmed: true,
	}
}
function resetBuyFormValues (form, airDatepicker) {
	const isIdField = (defaults, name) => {
		return defaults.hasOwnProperty(name + '_id');
	}
	const updateDate = (input, defaults) => {
		const { date_start, date_end, date, human_date_start, human_date_end } = defaults;
		const pickerFields = [ 'rangeDateFrom', 'rangeDateTo', 'selectedDates' ];
		const isFieldsExists = pickerFields
			.every(field => airDatepicker && airDatepicker.hasOwnProperty(field))

		input.value = date;

		if (airDatepicker && isFieldsExists) {
			airDatepicker.rangeDateFrom = date_start;
			airDatepicker.rangeDateTo = date_end;
			airDatepicker.selectedDates = [date_start, date_end];
			updateDurationView({ formattedDate: [human_date_start, human_date_end]});
		}
	}

	return () => {
		if (!form) {
			return;
		}

		const defaults = getFormDefaults();
		const selectedClass = 'buy__form-control--selected';
		const groupClass = 'buy__form-group';
		const tariffsSelectedClass = 'buy__form-tariff';
		const confirmedCheckboxes = Array.from(document.querySelectorAll('input[name="isConfirmed"]'));

		for (const element of form.elements) {
			const { name, type, dataset } = element;

			if (!name) {
				continue;
			}

			if (dataset.placeholder) {
				element.placeholder = dataset.placeholder;
			}



			if (name === 'insurer_birthday') {
				element.nextElementSibling.innerHTML = 'dd.mm.yyyy';
			}

			if (name === 'promo') {
				hideBuyInputError({target:element});
			}

			if (!defaults.hasOwnProperty(name) && type === 'checkbox') {
				// element.checked = true;
				// toggleBuyFormCheckbox({ target: element });
			} else if (!defaults.hasOwnProperty(name) && type !== 'checkbox') {
				element.value = '';
			} else if (name === 'type' || name === 'territory') {
				element.value = defaults[name] || '';
				element.setAttribute(defaults.id_attribute_name, defaults[name + '_id'] || '');
				updateSelectedItem(getListElements(element), defaults[name + '_id'] || '', selectedClass)
			} else if (name === 'promo') {
				hidePromoSuccess({ target: element });
			} else if (name === 'tariff') {
				element.value = defaults[name];
				element.setAttribute(defaults.id_attribute_name, defaults[name + '_id']);
				updateSelectedTariff(defaults[name + '_id'], tariffsSelectedClass, '--active')
			} else if (name === 'date') {
				updateDate(element, defaults);
			} else if (defaults.hasOwnProperty(name) && type === 'checkbox') {
				// element.checked = !defaults[name];
				// toggleBuyFormCheckbox({ target: element });
			} else if (defaults.hasOwnProperty(name)) {
				element.value = defaults[name];
			}
		}

		confirmedCheckboxes.forEach(checkbox => {
			checkbox.checked = true;
			toggleBuyFormCheckbox({ target: checkbox });
		})
		travellingCheckbox = document.querySelector('input[name="isTravelling"]');
		travellingCheckbox.checked = false;
		toggleBuyFormCheckbox({ target: travellingCheckbox });

		const { reset, groupWrapper } = multiSelect;
		const itemClass = 'buy__form-control--multiselect-list-item';
		const input = groupWrapper.querySelector('input[name="territories"]');
		const options = input.parentElement.parentElement.lastElementChild.firstElementChild.children;

		reset();
		input.parentElement.insertBefore(createSelectItem(itemClass,  defaults.territory, defaults.territory_id), input);
		updateSelectedItem(options, defaults.territory_id, selectedClass);
	}
}
function datePickerHeaderHandler ({ navigationClass, headerClass }, clickHandlerCb = (e) => {}) {
	const createHeader = () => {
		const headerWrapper = document.createElement('div');
		const [ startDateSpan, endDateSpan ] = (new Array(2)).fill(0)
			.map(el => document.createElement('span'));
		const [ arrowImg, closeImg ] = (new Array(2)).fill(0)
			.map(el => document.createElement('img'));
		const closeButton = document.createElement('button');

		startDateSpan.textContent = labels.startDate;
		arrowImg.src = images.arrow;
		arrowImg.setAttribute('alt', 'Arrow icon');
		endDateSpan.textContent = labels.endDate;
		// closeImg.src = images.close;
		closeButton.innerHTML = `
			<svg
			  width="24"
			  height="24"
			  viewBox="0 0 24 24"
			  fill="none"
			  xmlns="http://www.w3.org/2000/svg"
			>
			  <path
				d="M18.3002 5.71022C18.2077 5.61752 18.0978 5.54397 17.9768 5.49379C17.8559 5.44361 17.7262 5.41778 17.5952 5.41778C17.4643 5.41778 17.3346 5.44361 17.2136 5.49379C17.0926 5.54397 16.9827 5.61752 16.8902 5.71022L12.0002 10.5902L7.11022 5.70022C7.01764 5.60764 6.90773 5.5342 6.78677 5.4841C6.6658 5.43399 6.53615 5.4082 6.40522 5.4082C6.27429 5.4082 6.14464 5.43399 6.02368 5.4841C5.90272 5.5342 5.79281 5.60764 5.70022 5.70022C5.60764 5.79281 5.5342 5.90272 5.4841 6.02368C5.43399 6.14464 5.4082 6.27429 5.4082 6.40522C5.4082 6.53615 5.43399 6.6658 5.4841 6.78677C5.5342 6.90773 5.60764 7.01764 5.70022 7.11022L10.5902 12.0002L5.70022 16.8902C5.60764 16.9828 5.5342 17.0927 5.4841 17.2137C5.43399 17.3346 5.4082 17.4643 5.4082 17.5952C5.4082 17.7262 5.43399 17.8558 5.4841 17.9768C5.5342 18.0977 5.60764 18.2076 5.70022 18.3002C5.79281 18.3928 5.90272 18.4662 6.02368 18.5163C6.14464 18.5665 6.27429 18.5922 6.40522 18.5922C6.53615 18.5922 6.6658 18.5665 6.78677 18.5163C6.90773 18.4662 7.01764 18.3928 7.11022 18.3002L12.0002 13.4102L16.8902 18.3002C16.9828 18.3928 17.0927 18.4662 17.2137 18.5163C17.3346 18.5665 17.4643 18.5922 17.5952 18.5922C17.7262 18.5922 17.8558 18.5665 17.9768 18.5163C18.0977 18.4662 18.2076 18.3928 18.3002 18.3002C18.3928 18.2076 18.4662 18.0977 18.5163 17.9768C18.5665 17.8558 18.5922 17.7262 18.5922 17.5952C18.5922 17.4643 18.5665 17.3346 18.5163 17.2137C18.4662 17.0927 18.3928 16.9828 18.3002 16.8902L13.4102 12.0002L18.3002 7.11022C18.6802 6.73022 18.6802 6.09022 18.3002 5.71022Z"
				fill="#221B37"
			  />
			</svg>
		`;
		closeButton.setAttribute(defaults.calendar_close_attribute_name, 'true');
		headerWrapper.classList.add(headerClass);
		headerWrapper.append(startDateSpan, arrowImg, endDateSpan, closeButton);

		return headerWrapper;
	}
	const insertHeader = () => {
		const navigationBlock = document.getElementsByClassName(navigationClass)[0];

		if (navigationBlock) {
			navigationBlock.parentElement.insertBefore(headerBlock, navigationBlock);
		}
	}
	const updateHeaderLabels = ({ formattedDate }) => {
		const [ startDate, endDate ] = formattedDate;
		const startLabel = headerBlock.firstElementChild;
		const endLabel = headerBlock.firstElementChild.nextElementSibling.nextElementSibling;

		startLabel.textContent = startDate || labels.startDate;
		endLabel.textContent = endDate || labels.endDate;
	}
	const headerBlock = createHeader();

	headerBlock.addEventListener('click', clickHandlerCb);

	return {
		insertHeader,
		updateHeaderLabels,
	}
}
function setBuyFormHandlers (buyForm) {
	if (!buyForm) {
		return;
	}

	const tags = [ 'INPUT', 'TEXTAREA' ];
	// const filterTerritorySelect = filterSelect({
	// 	hiddenClass: 'buy__form-control--hidden',
	// 	activeClass: 'buy__form-control--select--active',
	// 	selectedClass: 'buy__form-control--selected',
	// });
	const filterTerritoriesSelect = filterMultiSelect({
		hiddenClass: 'buy__form-control--hidden',
		activeClass: 'buy__form-control--select--active',
		selectedClass: 'buy__form-control--selected',
	});
	const filterEmailSelect = filterEmail({
		hiddenClass: 'buy__form-control--hidden',
		activeClass: 'buy__form-control--select--active',
	});

	for (const element of buyForm.elements) {
		const { tagName, name } = element;
		const [ _, fieldName ] = name.split('_')

		if (!tags.includes(tagName)) {
			continue;
		}

		savePlaceholder(element);
		element.addEventListener('focus', hideBuyInputError);
		element.addEventListener('focus', hidePlaceholder);
		element.addEventListener('blur', checkBuyInputValue);
		element.addEventListener('blur', (e) => {
			const { name } = e.target;

			if (name === 'territories' && multiSelect.getSelectEntries().length) {
				return;
			}

			showPlaceholder(e);
		});

		// if (name === 'territory') {
		// 	element.addEventListener('keyup', throttle(filterTerritorySelect, 300));
		// 	element.addEventListener('focus', buySelect.showSelectList);
		// }

		if (name === 'territories') {
			element.addEventListener('keyup', throttle(filterTerritoriesSelect, 300));
			element.addEventListener('focus', buyMultiSelect.showSelectList);
		}

		if (name === 'type') {
			element.addEventListener('focus',  buySelect.showSelectList);
		}

		if (name === 'date') {
			element.addEventListener('blur', updateBuyFormPrice);
		}

		if (name === 'subscription_date') {
			element.addEventListener('blur', updateBuyFormPrice);
		}

		if (name === 'promo') {
			element.addEventListener('focus', hidePromoSuccess);
			element.addEventListener('input', filterNonLatin);
			// element.addEventListener('blur', checkPromoCode);
			element.addEventListener('blur', (e) => {
				// if (e.target.value) {
					updateBuyFormPrice();
				// }
			});
		}

		if (fieldName === 'email') {
			element.addEventListener('keyup', filterEmailSelect);
		}

		if (fieldName === 'birthday') {
			element.addEventListener('keyup', maskInputAndSetMaskedDate);
			// element.addEventListener('keyup', dateInputMask);
			element.addEventListener('blur', updateBuyFormPrice);
			element.addEventListener('keyup', syncBirthdayInputs.listener);
		}

		if (fieldName === 'name') {
			element.addEventListener('keyup', syncNameInputs.listener);
		}

		if (fieldName === 'lastname') {
			element.addEventListener('keyup', syncLastNameInputs.listener);
		}

		if (fieldName === 'passport') {
			element.addEventListener('keyup', syncPassportInputs.listener);
		}

		if (name === 'promo') {
			element.addEventListener('keyup', syncPromoInputs.listener);
		}

		if (['name', 'lastname', 'passport'].includes(fieldName)) {
			element.addEventListener('input', modifyValueToUpperCase);
		}
	}

	buyForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		const formBodyClass = 'buy__form-body';
		const formBodies = Array.from(document.getElementsByClassName(formBodyClass));
		const { merchant, merchantId } = e.target.dataset;
		const body = validateForm(e.target);
		const { pathname, search } = window.location;
		const loader = document.getElementById('loader-modal');
		const { isSubscription, subscription_date } = body;
		const subscription_dates = getFormatDates(subscription_date).join(defaults.date_separator);
		let dateElementId = 'date';

		if (isSubscription) {
			body.date = subscription_dates;
			dateElementId = 'subscription_date';
		}

		if (!validateDateInput({ value: body.date })) {
			body.isValid = false;
			body.errorFields.push(dateElementId);
			body.errorInputs.push(document.getElementById(dateElementId));
		}

		body.countries = multiSelect.getSelectEntries()
			.map(([_, id]) => id);

		if (!multiSelect.validate()) {
			body.isValid = false;
			body.errorFields.push('territories');
			body.errorInputs.push(document.querySelector('input[name="territories"]'));
		}

		const { details, insurer, tourists } = groupUpBuyFormBody(body);
		const { name, lastname, passport, birthday } = insurer;

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkBuyInputValue({ target: input }));

			return;
		}

		if (!formBodies.length || !formBodies[formBodies.length - 1].classList.contains(formBodyClass + '--active')) {
			return;
		}

		const isDiscount = timer.showCurrentTimestamp() > 0;
		const {
			date_from, date_to, countries, program_id,
			already_traveling, promo_code, travel_type, is_subscription
		} = normalizeDetails(details);

		if (!tourists.length) {
			tourists.push({ name, lastname, passport, birthday });
		}

		showModalById('loader-modal');
		// sendInfoGa(4);
		sendInfoFba(3);

		sendRequestAndSaveToken('/api/create_policy', {
			method: 'POST',
			body: JSON.stringify({
				program_id,
				date_from,
				date_to,
				travel_type,
				already_traveling,
				is_subscription,
				countries,
				promo_code,
				insurer: normalizePerson(insurer),
				tourists: tourists.map(normalizePerson),
				additional_services: [],
				year_program: false,
				discount_available: isDiscount,
				locale: labels.locale,
				user_path: `${pathname}${search}`,
				card_type: merchantId,
			}),
		}).then(async ({ response }) => {
			if (!response || !response.success) {
                hideCurrentModal({ target: loader });
				showModalById('error-modal');

				return;
			}

			const { payment_link, order_id } = response;

			await sendInfoGa(4, { order_id });

			// window.open(payment_link, "_blank") || window.location.replace(payment_link);
			// checkPaymentResult(order_id);


			saveClientActivity(4, { id: order_id });
			localStorage.setItem('get_params', search);
			hideCurrentModal({ target: loader });
			window.location.assign(payment_link);

			// showModalById('success-modal');
			// setBuyFormStep(0);
			// resetForm();

		}).catch(e => {
			hideCurrentModal({ target: loader });
			showModalById('error-modal');
		})
	});
}
function anchorClickHandler (e) {
	const anchor = e.target.closest('a');

	if (!anchor) {
		return;
	}


	const { dataset, tagName } = anchor;
	const closestA = e.target.closest('a');
	const actions = {
		openModal: ({ openModal }) => {
			closeAllMenus();

			// if (openModal === 'cooperate-modal') {
			// 	loadOnceItiLib(true);
			// }

			showModalById(openModal);
		},
		setInput: ({ setInput, text, value }) => {
			if (e.target.parentElement.classList.contains('buy__form-control--excluded')) {
				return;
			}

			setInputValue({ setInput, text, value },'buy__form-control--selected');
		},
		setFormStep: ({ setFormStep }) => {
			const isValid = isBuyFormStepComplete(setFormStep, buyForm);

			if (isValid) {
				setBuyFormStep(parseInt(setFormStep));
			}
		},
	}

	if (tagName !== 'A') {
		return;
	}

	let isActionExists = false;

	// debugger;

	for (const action in actions) {
		if (dataset.hasOwnProperty(action)) {
			isActionExists = true;
			actions[action](dataset);
		}
	}

	if (isActionExists) {
		e.preventDefault();
	}
}
function buttonClickHandler (e) {
	const button = e.target.closest('button[type="button"]');
	const actions = {
		createPayment: ({ text, value }) => {
			let event;

			if (!text || !value ) {
				return;
			}

			if (typeof Event === 'function') {
				event = new Event('submit', {
					bubbles: true,
					cancelable: true,
				});
			} else {
				event = document.createEvent('Event');
				event.initEvent('submit', true, true);
			}

			buyForm.dataset.merchant = text;
			buyForm.dataset.merchantId = value;
			hideCurrentModal({target: document.getElementById('cards-modal')});
			buyForm.dispatchEvent(event);
		},
		createNewPayment: ({ createNewPayment }) => {
			if (!queryParams.hasOwnProperty('token')) {
				return;
			}

			const modal = button.parentElement.parentElement;

			hideCurrentModal({ target: modal });
			showModalById('loader-modal');
			sendRequestAndSaveToken('/api/pay_again_policy', {
				method: 'POST', body: JSON.stringify({
					token: queryParams.token,
					system: payment_system,
					locale: labels.locale,
				})
			}).then(({ response }) => {
				const loader = document.getElementById('loader-modal');

				hideCurrentModal({ target: loader });

				if (!response || !response.success) {
					showModalById('error-modal');

					return;
				}

				const { payment_link } = response;

				// window.open(payment_link, "_blank") || window.location.replace(payment_link);
				window.location.assign(payment_link);
			}).catch(e => {
				console.warn(e.message);
			});
		},
		openModal: ({ openModal }) => {
			closeAllMenus();

			// if (openModal === 'cooperate-modal') {
			// 	loadOnceItiLib(true);
			// }

			showModalById(openModal);
		},
		hideModal: ({ hideModal }) => {
			const target = document.getElementById(hideModal);

			if (target) {
				hideCurrentModal({ target });
			}
		},
		scrollTo: ({ scrollTo }, speed = 1000) => {
			let element = document.getElementById(scrollTo);
			const { innerWidth } = window;

			if (innerWidth > 768 && scrollTo === 'buy__form') {
				element = element.previousElementSibling;
			}

			if (element) {
				scrollToElement(element, speed);
			}
		},
		playVideo: ({ playVideo }) => {
			const element = document.getElementById(playVideo);

			if (element) {
				button.parentElement.remove();
				element.play();
			}
		},
		setInput: ({ setInput, text, value }) => {
			const startTariffId = '6';
			const { isTravelling } = validateForm(buyForm);

			if (isTravelling && value === startTariffId) {
				return;
			}

			setInputValue({ setInput, text, value }, 'buy__form-tariff');
		},
		setFormStep: ({ setFormStep }) => {
			const isValid = isBuyFormStepComplete(setFormStep, buyForm);

			if (isValid) {
				setBuyFormStep(parseInt(setFormStep));
			}
		},
		tourist: ({ tourist, id }) => {
			updateTourists({ tourist, id }, button);
		},
		toggleSelect: ({ toggleSelect }) => {
			const wrapperClass = 'buy__form-control--select';
			const selectWrapper = button.closest('.' + wrapperClass);

			if (selectWrapper && !selectWrapper.classList.contains(wrapperClass + '--active')) {
				for (const wrapper of document.getElementsByClassName('buy__form-prices')) {
					removeClassFromElement(wrapper, 'buy__form-prices', '--discount');
				}
			}


			switch (toggleSelect) {
				case 'territories':
					const controlClass = 'buy__form-control--multiselect';
					const { groupWrapper, validate } = multiSelect;
					const controlWrapper = groupWrapper
						.getElementsByClassName(controlClass + '--active');

					if (!validate() && controlWrapper.length) {
						addClassToElement(groupWrapper, 'buy__form-group', '--error');
					} else {
						removeClassFromElement(groupWrapper, 'buy__form-group', '--error');
					}

					buyMultiSelect.toggleSelectList(e);

					return;
				default:
					buySelect.toggleSelectList(e);
					return;
			}
		},
		removeTerritory: ({ value }) => {
			const territoryItem = button.parentElement;
			const controlElement = territoryItem.closest('.buy__form-control--multiselect');
			const multiSelectElements = controlElement.lastElementChild.firstElementChild.children;

			territoryItem.remove();
			Array.from(multiSelectElements).forEach(listElement => {
				const { dataset } = listElement.firstElementChild;

				if (dataset.value === value) {
					listElement.classList.remove('buy__form-control--selected');
				}
			});

			if (!multiSelect.getSelectEntries().length) {
				showPlaceholder({target: document.querySelector('input[name="territories"]')});
			}
			// const { groupWrapper, validate } = multiSelect;

			// if (!validate()) {
			// 	addClassToElement(groupWrapper, 'buy__form-group', '--error');
			// }

			updateBuyFormPrice();
		},
		action: ({ action, target }) => {
			switch (action) {
				case 'link':
					if (target) {
						const locale =  labels.locale === 'en' ? '' : '/' + labels.locale;
						const { search } = window.location;
						
						window.location.assign( locale + '/' + target + search);
					}

					return;
				default:
					return;
			}
		},
		showHint: ({ showHint }) => {
			// if (isMobile()) {
			// 	toggleHint(button, showHint);
			// } else {
			//
			// }
		},
	}

	if (!button) {
		return;
	}

	const { dataset } = button;

	for (const action in actions) {
		if (dataset.hasOwnProperty(action)) {
			actions[action](dataset);
		}
	}
}
function liClickHandler (e){
	const li =  e.target.closest('li');

	if (!li || !li.firstElementChild) {
		return;
	}

	const { dataset } = li.firstElementChild;
	const selectedClass = 'buy__form-control--selected';

	if (!dataset.setInput || dataset.setInput !== 'territories') {
		return;
	}

	const anchor = e.target.closest('a');

	if (anchor) {
		e.preventDefault();
	}

	const input = document.querySelector(`input[name="${dataset.setInput}"]`);
	const itemClass = 'buy__form-control--multiselect-list-item';
	const controlElement = li.closest('.buy__form-control--multiselect');
	const linksElement = li.closest('.buy__form-links');
	let insertedElement = null;
	const { groupWrapper, validate, getSelectEntries } = multiSelect;

	// if (dataset.value === '207' && dataset.text === 'Worldwide') {
	// 	const { reset, groupWrapper } = multiSelect;
	// 	const listCollection = groupWrapper.firstElementChild.nextElementSibling.lastElementChild.firstElementChild.children;
	//
	// 	reset();
	// 	insertedElement = input.parentElement.insertBefore(createSelectItem(itemClass, dataset.text, dataset.value), input);
	// 	updateSelectedItem(listCollection, dataset.value, selectedClass);
	// 	removeClassFromElement(groupWrapper, 'buy__form-group', '--error');
	//
	// 	return;
	// }

	if (controlElement) {
		if (li.classList.contains(selectedClass)) {
			const buttons = controlElement.firstElementChild.getElementsByTagName('button');

			removeClassFromElement(li, selectedClass);
			Array.from(buttons).forEach(button => {
				if (button.dataset.value === dataset.value) {
					button.parentElement.remove();
				}
			});

			if (!getSelectEntries().length) {
				showPlaceholder({target: input});
			}
		} else {
			const listCollection = controlElement.lastElementChild.firstElementChild.children;

			insertedElement = input.parentElement.insertBefore(createSelectItem(itemClass, dataset.text, dataset.value), input);
			// addMultiSelectListItem(input, 'buy__form-control--multiselect-list-item', dataset.text, dataset.value);
			addClassToElement(li, selectedClass);
			removeHiddenClassFromCollection(listCollection, 'buy__form-control--hidden');
			// input.focus();
			input.value = '';
			input.placeholder = '';
		}
	}

	if (linksElement) {
		const groupWrapper = linksElement.parentElement;
		const controlElement = groupWrapper.firstElementChild.nextElementSibling;
		const listCollection = controlElement.lastElementChild.firstElementChild.children;
		const buttons = controlElement.firstElementChild.getElementsByTagName('button');
		const isValueExists = Array.from(buttons)
			.some(button => button.dataset.value === dataset.value);

		if (!isValueExists) {
			insertedElement = input.parentElement.insertBefore(createSelectItem(itemClass, dataset.text, dataset.value), input);

			Array.from(listCollection).forEach(listElement => {
				if (listElement.firstElementChild.dataset.value === dataset.value) {
					addClassToElement(listElement, selectedClass);
				}
			});

			input.value = '';
			input.placeholder = '';

			// input.parentElement.scrollBy({
			// 	left: input.previousElementSibling.getBoundingClientRect().left,
			// 	behavior: 'smooth',
			// });
		}
	}

	if (!controlElement && !linksElement) {
		return;
	}

	// if (!validate()) {
	// 	addClassToElement(groupWrapper, 'buy__form-group', '--error');
	// } else {
	// 	removeClassFromElement(groupWrapper, 'buy__form-group', '--error');
	// }

	updateBuyFormPrice();
	scrollToLastAddedTerritory(-40);

	// if (insertedElement) {
	// 	const { left, width } = input.getBoundingClientRect();
	// 	const position = left - width - insertedElement.getBoundingClientRect().width - 16;
	//
	// 	console.log(position);
	//
	// 	insertedElement.parentElement.scrollBy({
	// 		left: position,
	// 		behavior: 'smooth',
	// 	});
	// }

	// const { width} = input.previousElementSibling.getBoundingClientRect();
	// const { left } = input.getBoundingClientRect();
	//
	// console.log(left, width);
	//
	// input.parentElement.scrollBy({
	// 	left: input.previousElementSibling.getBoundingClientRect().left - width * 3,
	// 	behavior: 'smooth',
	// });
	// scrollToElement(input.previousElementSibling, 300);
}
function downloadMultiOptions ({ url, method, inputSelector, dataAttribute, attributeValue  }, withLinks = false) {
	const getOptionListWrapperElement = (inputSelector) => {
		return  document.querySelector('input[name=territories]').parentElement;
	}
	const getOptionListElement = (element) => {
		return element ? element.parentElement.lastElementChild.firstElementChild : null;
	}
	const getLinksListElement = (element) => {
		return element ? element.parentElement.parentElement.lastElementChild : null;
	}
	const createLinkListElement = (id, text, associationText, dataAttribute, attributeValue) => {
		const li = document.createElement('li');
		const a = document.createElement('a');

		a.textContent = associationText;
		a.href = '#';
		a.setAttribute(defaults.text_attribute_name || 'data-text', text);
		a.setAttribute(defaults.id_attribute_name || 'data-value', id);
		a.setAttribute(dataAttribute, attributeValue);
		li.appendChild(a);

		return li;
	}
	const wrapper =  getOptionListWrapperElement(inputSelector);
	const optionList = getOptionListElement(wrapper);
	const linkList = getLinksListElement(wrapper);

	sendRequestAndSaveToken(url, { method })
		.then(({ response }) => {
			if (!response || !response.success) {
				return;
			}

			const { countries_list } = response;
			const linksAssociations = {
				'207': 'Worldwide',
				'208': 'Europe',
				'100': 'Thailand',
				'107': 'USA',
			}
			const optionElements = [];
			const linkElements = [];

			optionList.innerHTML = '';
			linkList.innerHTML = '';
			countries_list.forEach(({id, text}) => {
				const associationText = linksAssociations[`${id}`];

				if (associationText) {
					linkElements.push(createLinkListElement(id,text, associationText, dataAttribute, attributeValue));
				}

				optionElements.push(createLinkListElement(id,text, text, dataAttribute, attributeValue));
				updateSelectedItem(optionElements, defaults.territory_id, 'buy__form-control--selected');
			})
			optionList.append(...optionElements);
			linkList.append(linkElements[3], linkElements[0], linkElements[1], linkElements[2]);

			// updateBuyFormPrice(); // TODO rework
		}).catch(e => console.error(e.message))
}
function validateDateInput (input) {
	const {value, name} = input;
	let isValid = true;

    if (!value) {
        return false;
    }
	const regExp = /^\d{2}\.\d{2}\.\d{4}\s*[-–—‑]\s*\d{2}\.\d{2}\.\d{4}$/;
    if (!regExp.test(value)) {
        return false;
    }
    const [startDate, endDate] = value.split(' - ')
        .map(date => normalizeDate(date));
    const d = new Date();
    const currentDate = [
        d.getFullYear(),
        d.getMonth() + 1,
        d.getDate()
    ].map(n => n < 10 ? `0${n}` : n).join('-');
    if (startDate < currentDate) {
        return false;
    }
    if (startDate > endDate) {
        return false;
    }
    return isValid;
}
function createMultiSelect ({ multiSelectClass }) {
	const reset = () => {
		const buttons = listWrapper.getElementsByTagName('button');
		const options = optionsWrapper.children;

		Array.from(buttons).forEach(button => {
			button.parentElement.remove();
		});
		Array.from(options).forEach(option => {
			removeClassFromElement(option, 'buy__form-control--selected');
		})
	}
	const getEntries = (wrapper, tagName) => {
		const elements = wrapper.getElementsByTagName(tagName);

		return Array.from(elements)
			.map(({ dataset: { text, value }}) => [ text, value ]);
	}
	const validate = () => {
		const entries = getEntries(listWrapper, 'button')
			.map(value => JSON.stringify(value));
		const options = getEntries(optionsWrapper, 'a')
			.map(value => JSON.stringify(value));
		let isValid = true;

		if (!entries.length) {
			return false;
		}

		entries.forEach(value => {
			if (!options.includes(value)) {
				isValid = false;
			}
		});

		return isValid;
	}
	const multiSelectWrapper = document.getElementsByClassName(multiSelectClass)[0];
	const listWrapper = multiSelectWrapper.firstElementChild;
	const optionsWrapper = multiSelectWrapper.lastElementChild.firstElementChild;


	return {
		groupWrapper: multiSelectWrapper.parentElement,
		getSelectEntries: () => getEntries(listWrapper, 'button'),
		// getOptionsEntries: () => getEntries(optionsWrapper, 'a'),
		validate,
		reset,
	};
}
function modifyValueToUpperCase (e) {
	// const { target } = e;

	// target.value = target.value.toUpperCase();
	let value_arr = this.value.split('');
	this.value = value_arr.map(item => item.toUpperCase()).join('')
}
function filterNonLatin (e) {
	this.value = this.value.replace(/[^a-zA-Z0-9_]/g, '');
}
function createSyncInputsValues (inputSelectors = []) {
	const listener = (e) => {
		const { value, name } = e.target;
		const inputElements = [];
		const [ _, fieldName ] = name.split('_');
		const mask = 'dd.mm.yyyy';

		inputSelectors.forEach(selector => {
			const inputs = document.querySelectorAll(selector);

			if (inputs.length) {
				inputElements.push(...inputs);
			}
		});

		inputElements.forEach(inputElement => {
			if (inputElement === e.target) {
				return;
			}

			inputElement.value = value;

			if (fieldName === 'birthday') {
				inputElement.nextElementSibling.innerHTML = !value ? mask : `<span>${value}</span>` + mask.slice(value.length);
			}
		});
	}
	const add = (inputSelector) => inputSelectors.push(inputSelector);
	const remove = (inputSelector) => inputSelectors.filter(selector => selector !== inputSelector);
	const exists = (inputSelector) => inputSelectors.includes(inputSelector);

	return {
		listener,
		add,
		remove,
		exists,
	}
}
function createKeyboardClickHandler ({ triggerClass, selectedClass }) {
	const modifier = '--active';
	const topScrollMultiplier = 1000;
	const prev = (input, listElements) => {
		const current = listElements.findIndex(el => el.classList.contains(selectedClass));
		const listWrapper = input.parentElement.lastElementChild.firstElementChild;
		let prev = current - 1;

		if (prev < 0) {
			prev = listElements.length - 1;
		}

		if (current !== -1) {
			removeClassFromElement(listElements[current], selectedClass);
		}

		const { text, value } = listElements[prev].firstElementChild.dataset;

		// console.log(text, value)
		//
		// input.dataset.value = value;
		// input.dataset.value = text;
		input.value = text;
		addClassToElement(listElements[prev], selectedClass);
		listWrapper.scrollTo({
			top: (prev > 5 && prev <= listElements.length ? 1 : -1) * topScrollMultiplier,
			behavior: "smooth",
		});
	}
	const next = (input, listElements) => {
		const current = listElements.findIndex(el => el.classList.contains(selectedClass));
		const listWrapper = input.parentElement.lastElementChild.firstElementChild;
		let next = current + 1;

		if (next >= listElements.length) {
			next = 0;
		}

		if (current !== -1) {
			removeClassFromElement(listElements[current], selectedClass);
		}
		
		const { text, value } = listElements[next].firstElementChild.dataset;

		// console.log(text, value)
		//
		// input.dataset.value = value;
		// input.dataset.value = text;
		input.value = text;
		addClassToElement(listElements[next], selectedClass);
		listWrapper.scrollTo({
			top: (next > 5 ? 1 : -1) * topScrollMultiplier,
			behavior: "smooth",
		});
	}

	return (e) => {
		const selectElement = document.getElementsByClassName(triggerClass + modifier)[0];

		if (!selectElement) {
			return;
		}

		const hiddenClass = 'buy__form-control--hidden';
		const [ arrowUpBtn, arrowDownBtn, enterBtn ] = [ 38, 40, 13 ];
		const listElements = Array.from(selectElement.lastElementChild.firstElementChild.children)
			.filter(element => !element.classList.contains(hiddenClass));
		const input = selectElement.firstElementChild;

		switch (e.keyCode) {
			case arrowUpBtn:
				input.focus();
				prev(input, listElements);

				return;
			case arrowDownBtn:
				input.focus();
				next(input, listElements);

				return;
			case enterBtn:
				e.preventDefault();
				checkBuyInputValue({ target: input });
				buySelect.hideAllLists();
				showAddTouristBtn();

				return;
			default:
				return;
		}
	}
}
function setTariffs ({ slideClass, cardClass, optionClass, images }) {
	const modifiers = {
		price: '-price',
		coverage:'-coverage',
		button: '-button',
		list: '-list',
		item: '-item',
		included: '--included',
		excluded: '--excluded',
		lineTrougth: '--line-trougth',
		black: '-black',
		white: '-white',
		light: '--light',
		shadowed: '--shadowed',
		right: '--right',
	}
	const labels = {
		optionsAvailable: 'options available',
		price: 'Price',
		day: 'day',
		coverage: 'Coverage amount:',
		buyInsurance: 'Buy insurance',
		buyNow: 'Buy Now',
	}
	const getOptionsCount = (option_groups) => option_groups.reduce((acc, { options }) => {
		acc += options.filter(({ included }) => included).length;

		return acc;
	}, 0);
	const createOptions = (options, isLight = false) => {
		return options.map(({ name, included, link, hint }) => {
			const { dangerWhite, dangerBlack } = images;
			const li = document.createElement('li');
			const span = document.createElement('span');
			const itemClass = optionClass + modifiers.item;
			const statusClass = itemClass + modifiers[ included ? 'included' : 'excluded' ];
			const hintClass = itemClass + modifiers.right;

			span.textContent = name;
			li.classList.add(itemClass, statusClass);
			li.appendChild(span);

			if (link && hint) {
				const button = document.createElement('button');
				const image = document.createElement('img');
				const spanHint = document.createElement('span');

				button.setAttribute('type', 'button');
				image.setAttribute('alt', 'Info icon');
				image.setAttribute('src', isLight ? dangerBlack : dangerWhite);
				spanHint.textContent = hint;
				button.append(image, spanHint);
				li.classList.add(hintClass);
				li.appendChild(button);
			}

			return li;
		});
	}
	const createTariffCard = ({ id, name, price, discount_price, currency, coverage_amount, option_groups, modifier }) => {
		const itemClass = optionClass + modifiers.item;
		const isLight = modifier === '--light';
		const optionsCount = getOptionsCount(option_groups);
		const slide = document.createElement('div');
		const card = document.createElement('div');
		const h3 = document.createElement('h3');
		const spanName = document.createElement('span');
		const spanDescription = document.createElement('span');
		const priceWrapper = document.createElement('div');
		const priceTitle = document.createElement('p');
		const priceDiscount = document.createElement('p');
		const priceFull = document.createElement('p');
		const button = document.createElement('button');
		const coverageWrapper = document.createElement('div');
		const coverageTitle = document.createElement('p');
		const coverageFull = document.createElement('p');
		const ul = document.createElement('ul');
		const optionGroups = option_groups.map(({ name, included, options }) => {
			const { chevronDownWhite, chevronDownBlack } = images;
			const li = document.createElement('li');
			const image = document.createElement('img');
			const h4 = document.createElement('h4');
			const span = document.createElement('span');
			const ul = document.createElement('ul');

			image.setAttribute('src', isLight ? chevronDownBlack : chevronDownWhite);
			image.setAttribute('alt', 'Chevron icon');
			span.textContent = name;
			h4.append(image, span);
			ul.classList.add(itemClass + modifiers.list);
			ul.append(...createOptions(options, isLight));

			if (!included) {
				li.classList.add(optionClass + modifiers.lineTrougth);
			}

			li.append(h4, ul);

			return li;
		});
		const perDay = ' ' + currency + '/' + labels.day;

		spanName.textContent = name;
		spanDescription.textContent = optionsCount + ' ' + labels.optionsAvailable;
		h3.append(spanName, spanDescription);
		priceTitle.textContent = labels.price;
		priceDiscount.textContent = discount_price + perDay;
		priceFull.textContent = price + perDay;
		priceWrapper.classList.add(cardClass + modifiers.price);
		priceWrapper.append(priceTitle, priceDiscount, priceFull);
		button.setAttribute('type', 'button');
		button.setAttribute('aria-label', labels.buyInsurance);
		button.setAttribute('data-text', name);
		button.setAttribute('data-value', id);
		button.setAttribute('data-set-input', 'tariff');
		button.setAttribute('data-scroll-to', 'buy__form');
		button.textContent = labels.buyNow;
		button.classList.add(cardClass + modifiers.button);
		coverageTitle.textContent = labels.coverage;
		coverageFull.textContent = coverage_amount + ' ' + currency;
		coverageWrapper.classList.add(cardClass + modifiers.coverage);
		coverageWrapper.append(coverageTitle, coverageFull);
		ul.append(...optionGroups);
		card.classList.add(cardClass);

		if (modifier) {
			card.classList.add(cardClass + modifier);
		}

		card.append(h3, priceWrapper, button, coverageWrapper, ul);
		slide.appendChild(card);

		return slide;
	}

	// sendRequestAndSaveToken('/api/get_tariffs_info', { method: 'POST' })
	// 	.then(({ response }) => {
	// 		console.log(response);
	// 	}).catch(e => console.error(e.message));
}
function updateTariffsCardPrice(timestamp = 0) {
	if (timestamp > 0) {
		return;
	}

	const priceWrappers = document.getElementsByClassName('tariffs__card-price');

	Array.from(priceWrappers).forEach(priceWrapper => {
		const fullPriceElement = priceWrapper.lastElementChild

		fullPriceElement.previousElementSibling.textContent = fullPriceElement.textContent;
		fullPriceElement.style.display = 'none';
	});
}
function setMaskedDate(str, mask) {
	const parts = str.toString().split('.');
	const placeholders = ['dd', 'mm', 'yyyy'];
	let result = mask;

	for (let i = 0; i < parts.length; i++) {
		const placeholder = placeholders[i];
		const value = parts[i];
		if (value) {
			// Replace only the first N characters of the placeholder
			result = result.replace(placeholder, value + placeholder.slice(value.length));
		}
	}

	return result;
}
function maskInputAndSetMaskedDate (e) {
	dateInputMask(e);

	const { value, dataset: { placeholder }} = e.target;
	const mask = placeholder || 'dd.mm.yyyy';
	// const maskedValue = setMaskedDate(value, mask);

	e.target.nextElementSibling.innerHTML = !value ? mask : `<span>${value}</span>` + mask.slice(value.length);
}

function scrollToInputAndFocusAdvanced(input, options = {}) {
	// Default options
	const defaults = {
		speed: 'smooth',        // 'smooth', 'instant', or number (ms for custom animation)
		block: 'center',        // 'start', 'center', 'end', 'nearest'
		inline: 'nearest',      // 'start', 'center', 'end', 'nearest'
		offset: 0,              // Additional offset in pixels
		selectAll: false,       // Select all text in input
		callback: null          // Callback function after focus
	};

	const config = { ...defaults, ...options };

	if (!input || !input.nodeType) {
		console.error('Invalid input element provided');
		return Promise.reject('Invalid input element');
	}

	return new Promise((resolve, reject) => {
		try {
			// Apply offset if specified
			if (config.offset !== 0) {
				const rect = input.getBoundingClientRect();
				const targetY = window.pageYOffset + rect.top + config.offset;

				if (typeof config.speed === 'number') {
					// Custom smooth scroll animation
					smoothScrollToY(targetY, config.speed, () => {
						focusInput(input, config, resolve);
					});
				} else {
					window.scrollTo({
						top: targetY,
						behavior: config.speed
					});

					const delay = config.speed === 'instant' ? 0 : 300;
					setTimeout(() => focusInputAdvanced(input, config, resolve), delay);
				}
			} else {
				// Standard scrollIntoView
				input.scrollIntoView({
					behavior: typeof config.speed === 'number' ? 'smooth' : config.speed,
					block: config.block,
					inline: config.inline
				});

				const delay = config.speed === 'instant' ? 0 :
					typeof config.speed === 'number' ? config.speed : 300;

				setTimeout(() => focusInputAdvanced(input, config, resolve), delay);
			}
		} catch (error) {
			reject(error);
		}
	});
}

// Helper function to focus input with options
function focusInputAdvanced(input, config, resolve) {
	input.focus();

	// Handle text selection
	if (input.type === 'text' || input.type === 'email' || input.type === 'password' ||
		input.type === 'search' || input.tagName === 'TEXTAREA') {

		if (config.selectAll) {
			input.select();
		} else {
			// Move cursor to end
			const length = input.value.length;
			input.setSelectionRange(length, length);
		}
	}

	// Execute callback if provided
	if (config.callback && typeof config.callback === 'function') {
		config.callback(input);
	}

	if (resolve) resolve(input);
}


function reduceElementHeight(element, speed = 300) {
	return new Promise((resolve, reject) => {
		// Validate element
		if (!element || !element.nodeType) {
			reject(new Error('Invalid element provided'));
			return;
		}

		// Store original values
		const originalHeight = element.offsetHeight;
		const originalOpacity = window.getComputedStyle(element).opacity;
		const originalOverflow = element.style.overflow;
		const originalTransition = element.style.transition;

		// Set initial styles for animation
		element.style.height = originalHeight + 'px';
		element.style.overflow = 'hidden';
		element.style.transition = `height ${speed}ms ease-out, opacity ${speed}ms ease-out`;

		// Force reflow to ensure initial styles are applied
		element.offsetHeight;

		// Start animation
		element.style.height = '0px';
		element.style.opacity = '0';

		// Handle animation completion
		const handleTransitionEnd = (event) => {
			// Only handle height or opacity transitions for this element
			if (event.target === element &&
				(event.propertyName === 'height' || event.propertyName === 'opacity')) {

				// Remove transition listener
				element.removeEventListener('transitionend', handleTransitionEnd);

				// Restore original transition
				element.style.transition = originalTransition;

				resolve(element);
			}
		};

		// Add transition end listener
		element.addEventListener('transitionend', handleTransitionEnd);

		// Fallback timeout in case transitionend doesn't fire
		const fallbackTimeout = setTimeout(() => {
			element.removeEventListener('transitionend', handleTransitionEnd);
			element.style.transition = originalTransition;
			resolve(element);
		}, speed + 100);

		// Clear fallback if transition completes normally
		element.addEventListener('transitionend', () => {
			clearTimeout(fallbackTimeout);
		}, { once: true });
	});
}

function hideAddTouristBtn () {
	const buttonClass = 'buy__form-body-button';
	const modifier = '--hidden';

	Array.from(document.getElementsByClassName(buttonClass)).forEach(button => {
		addClassToElement(button, buttonClass, modifier);
	});
}

function showAddTouristBtn () {
	const buttonClass = 'buy__form-body-button';
	const modifier = '--hidden';

	Array.from(document.getElementsByClassName(buttonClass + modifier)).forEach(button => {
		removeClassFromElement(button, buttonClass, modifier);
	});
}

function scrollUpByElementHeight(element, speed = 300) {
	return new Promise((resolve, reject) => {
		// Validate element
		if (!element || !element.nodeType) {
			reject(new Error('Invalid element provided'));
			return;
		}

		// Get element height
		const elementHeight = element.offsetHeight;

		// If element has no height, resolve immediately
		if (elementHeight <= 0) {
			resolve({ scrolled: 0, element: element });
			return;
		}

		// Get current scroll position
		const startScrollY = window.pageYOffset || document.documentElement.scrollTop;
		const targetScrollY = Math.max(0, startScrollY - elementHeight);
		const scrollDistance = startScrollY - targetScrollY;

		// If no scrolling needed, resolve immediately
		if (scrollDistance <= 0) {
			resolve({ scrolled: 0, element: element });
			return;
		}

		// Handle instant scroll
		if (speed === 0 || speed === 'instant') {
			window.scrollTo(0, targetScrollY);
			resolve({ scrolled: scrollDistance, element: element });
			return;
		}

		// Smooth scroll animation
		const startTime = performance.now();

		function animateScroll(currentTime) {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / speed, 1);

			// Easing function (ease-out)
			const easeOut = 1 - Math.pow(1 - progress, 3);

			// Calculate current scroll position
			const currentScrollY = startScrollY - (scrollDistance * easeOut);

			window.scrollTo(0, currentScrollY);

			if (progress < 1) {
				requestAnimationFrame(animateScroll);
			} else {
				resolve({
					scrolled: scrollDistance,
					element: element,
					finalPosition: targetScrollY
				});
			}
		}

		requestAnimationFrame(animateScroll);
	});
}

function scrollToElementPromisified(element, speed = 300) {
	return new Promise((resolve, reject) => {
		// Validate element
		if (!element || !element.nodeType) {
			reject(new Error('Invalid element provided'));
			return;
		}

		// Check if element is visible
		if (element.offsetParent === null) {
			reject(new Error('Element is not visible'));
			return;
		}

		// Get element position
		const elementRect = element.getBoundingClientRect();
		const startScrollY = window.pageYOffset || document.documentElement.scrollTop;
		const targetScrollY = startScrollY + elementRect.top;
		const scrollDistance = targetScrollY - startScrollY;

		// If already at target position, resolve immediately
		if (Math.abs(scrollDistance) < 1) {
			resolve({
				element: element,
				scrolled: 0,
				finalPosition: targetScrollY
			});
			return;
		}

		// Handle instant scroll
		if (speed === 0 || speed === 'instant') {
			window.scrollTo(0, targetScrollY);
			resolve({
				element: element,
				scrolled: scrollDistance,
				finalPosition: targetScrollY
			});
			return;
		}

		// Smooth scroll animation
		const startTime = performance.now();

		function animateScroll(currentTime) {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / speed, 1);

			// Easing function (ease-out)
			const easeOut = 1 - Math.pow(1 - progress, 3);

			// Calculate current scroll position
			const currentScrollY = startScrollY + (scrollDistance * easeOut);

			window.scrollTo(0, currentScrollY);

			if (progress < 1) {
				requestAnimationFrame(animateScroll);
			} else {
				resolve({
					element: element,
					scrolled: scrollDistance,
					finalPosition: targetScrollY
				});
			}
		}

		requestAnimationFrame(animateScroll);
	});
}

function loadItiLib (showLoader = false) {
	const loaderId = 'loader-modal';

	if (showLoader) {
		showModalById(loaderId);
	}
	insertStyleLink(labels.baseUrl + 'libs/intlTelInput/intl-tel-input.min.css', mainStyle)
		.then((res) => insertScript(labels.baseUrl + 'libs/intlTelInput/intl-tel-input.min.js', mainScrypt))
		.then((res) => insertScript(labels.baseUrl + 'libs/intlTelInput/utils.min.js', mainScrypt))
		.then((res) => {
			const loader = document.getElementById(loaderId);

			setItiPhoneInputs(intlTelInput);

			if (showLoader && loader && loader.classList.contains('modal__active')) {
				hideCurrentModal({ target: loader });
			}
		});
}

function loadAirPickerLib () {
	insertStyleLink(labels.baseUrl + 'libs/air-datepicker/air-datepicker-modified.min.css', mainStyle)
		.then((res) => insertScript(labels.baseUrl + 'libs/air-datepicker/air-datepicker.js', mainScrypt))
		.then((res) => {
			const buyFormSubscriptionDatePicker = new AirDatepicker('#subscription_date', {
				range: false,
				// multipleDatesSeparator: ' - ',
				selectedDates: [defaults.date_start],
				minDate: defaults.date_start,
				// maxDate: defaults.max_date,
				// isMobile: true,
				locale: {
					days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
					daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
					months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
					today: 'Today',
					clear: 'Clear',
					timeFormat: 'hh:mm aa',
					firstDay: 0
				},
				navTitles: {
					days: 'MMMM <i>yyyy</i>'
				},
				onShow: (isFinished) => {
					if (isFinished) {
						return;
					}

					const { insertHeader, updateHeaderLabels } = pickerHeader;
					const input = buyFormSubscriptionDatePicker.$el;
					const { value } = input;
					const formattedDate = getFormatDates(value);

					insertHeader();
					updateHeaderLabels({ formattedDate });
					updateDateInputMask(input, formattedDate);
				},
				onSelect: ({date, formattedDate, datepicker}) => {
					const { updateHeaderLabels } = pickerHeader;
					const input = datepicker.$el;

					// const isValid = validateDateInput(input);

					formattedDate = getFormatDates(formattedDate);
					updateHeaderLabels({ formattedDate });
					updateDateInputMask(input, formattedDate);
					setTimeout(() => datepicker.hide(), 300);
				},
				onHide: (isFinished) => {
					if (!isFinished) {
						return;
					}

					const input = buyFormSubscriptionDatePicker.$el;
					const formattedDate = getFormatDates(input.value);
					const isValid = validateDateInput({ value: formattedDate.join(defaults.date_separator) });
					const groupClass = 'buy__form-group';
					const groupElement = input.closest('.' + groupClass);

					if (!isValid) {
						addClassToElement(groupElement, groupClass, '--error');
					}
				}
			});
			const buyFormDatePicker = new AirDatepicker('#date', {
				range: true,
				multipleDatesSeparator: ' - ',
				selectedDates: [defaults.date_start, defaults.date_end],
				minDate: defaults.date_start,
				// maxDate: defaults.max_date,
				// isMobile: true,
				locale: {
					days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
					daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
					daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
					months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
					today: 'Today',
					clear: 'Clear',
					timeFormat: 'hh:mm aa',
					firstDay: 0
				},
				navTitles: {
					days: 'MMMM <i>yyyy</i>'
				},
				onShow: (isFinished) => {
					if (isFinished) {
						return;
					}

					const { insertHeader, updateHeaderLabels } = pickerHeader;
					const formattedDate = buyFormDatePicker.$el.value.split(defaults.date_separator);

					insertHeader();
					updateHeaderLabels({ formattedDate });
				},
				onSelect: ({ date, formattedDate, datepicker }) => {
					const { updateHeaderLabels } = pickerHeader;

					if (!Array.isArray(date) || date.length < 2) {
						updateHeaderLabels({ formattedDate });
						updateDurationView({ formattedDate });
						return;
					}

					const [start, end] = date;

					// 6 суток между началом и концом
					const diffDays = Math.floor(
						(Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()) -
							Date.UTC(start.getFullYear(), start.getMonth(), start.getDate())) /
						86400000
					);

					if (diffDays < 6) {
						const correctedEnd = new Date(start);
						correctedEnd.setDate(correctedEnd.getDate() + 6);

						// Дать AirDatepicker завершить собственный выбор,
						// затем заменить выбранный диапазон.
						setTimeout(() => {
							datepicker.selectDate([start, correctedEnd], { silent: true });

							const correctedFormattedDate = [start, correctedEnd].map(
								d => datepicker.formatDate(d, 'dd.MM.yyyy')
							);

							updateHeaderLabels({ formattedDate: correctedFormattedDate });
							updateDurationView({ formattedDate: correctedFormattedDate });
							datepicker.hide();
						}, 0);

						return;
					}

					updateHeaderLabels({ formattedDate });
					updateDurationView({ formattedDate });
					datepicker.hide();
				},
				// onSelect: ({date, formattedDate, datepicker}) => {
				// 	const { updateHeaderLabels } = pickerHeader;
				//
				// 	updateHeaderLabels({ formattedDate });
				// 	updateDurationView({ formattedDate });
				// 	if (date.length < 2) {
				// 		return;
				// 	}
				//
				// 	datepicker.hide();
				// },
				onHide: (isFinished) => {
					if (!isFinished) {
						return;
					}

					const input = buyFormDatePicker.$el;
					const isValid = validateDateInput(input);
					const groupClass = 'buy__form-group';
					const groupElement = input.closest('.' + groupClass);

					if (!isValid) {
						addClassToElement(groupElement, groupClass, '--error');
					}
				}
			});
			const pickerHeader = datePickerHeaderHandler({
				navigationClass: classes.navigationClass,
				headerClass: classes.pickerClass,
			}, (e) => {
				const button = e.target.closest('button');

				if (button) {
					buyFormDatePicker.hide()
				}
			});


			const input = buyFormSubscriptionDatePicker.$el;
			const d = defaults.date_start;
			const value = [
				d.getDate(),
				d.getMonth() + 1,
				d.getFullYear()
			].map(n => n < 10 ? `0${n}` : `${n}`).join('.');
			const formattedDate = getFormatDates(value);

			updateDateInputMask(input, formattedDate);
			resetForm = resetBuyFormValues(buyForm, buyFormDatePicker);
			isPickerLoaded = true;
		});
}

function loadSwiperLib () {
	insertStyleLink(labels.baseUrl + 'libs/swiperJS/swiper-bundle.min.css', mainStyle)
		.then((res) => insertScript(labels.baseUrl + 'libs/swiperJS/swiper-bundle.min.js', mainScrypt))
		.then((res) => {
			removePreviewAndLoadSwiperStyles();

			const reviewsSlider = new Swiper(".reviews__slider", {
				// autoplay: {
				// 	delay: 2000,
				// },
				// loop: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: '.reviews__arrow--next',
					prevEl: '.reviews__arrow--prev',
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 10,
						loop: false,
					},
					481: {
						slidesPerView: 2,
						spaceBetween: 10,
					},
					993: {
						slidesPerView: 3,
						spaceBetween: 10,
						effect: "coverflow",
						coverflowEffect: {
							rotate: 0,
							stretch: -50,
							depth: 30,
							modifier: 1,
							slideShadows: false,
						},
					},
					1201: {
						slidesPerView: 5,
						effect: "coverflow",
						spaceBetween: 10,
						coverflowEffect: {
							rotate: 0,
							stretch: -50,
							depth: 30,
							modifier: 1,
							slideShadows: false,
						},
					}
				},
			});
			reviewsSlider.on('activeIndexChange', (swiper) => {
				setDisabledState(swiper, 'reviews__arrow');
			});
			const tariffsSlider = new Swiper(".tariffs__slider", {
				slidesPerView: 3,
				spaceBetween: 10,
				navigation: {
					nextEl: '.tariffs__arrow--next',
					prevEl: '.tariffs__arrow--prev',
				},
				breakpoints: {
					320: {
						slidesPerView: 1
					},
					480: {
						slidesPerView: 1,
						spaceBetween: 10,
					},
					// 769: {
					// 	slidesPerView: 2,
					// 	// spaceBetween: 20,
					// },
					993: {
						slidesPerView: 3,
						spaceBetween: 20,
					},
				}
			});
			tariffsSlider.slideTo(1, 400);
			tariffsSlider.on('activeIndexChange', (swiper) => {
				setDisabledState(swiper, 'tariffs__arrow');
			});
			const trustUsSwiper = new Swiper(".trust-us__cards", {
				// autoplay: {
				// 	delay: 2000,
				// },
				// loop: true,
				spaceBetween: 10,
				navigation: {
					nextEl: '.trust-us__arrow--next',
					prevEl: '.trust-us__arrow--prev',
				},
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				breakpoints: {
					320: {
						slidesPerView: 1,
					},
					481: {
						slidesPerView: 2
					},
					769: {
						slidesPerView: 3
					},
					// 993: {
					// 	slidesPerView: 4
					// },
					1201: {
						slidesPerView: 4
					},
				}
			});
			trustUsSwiper.on('activeIndexChange', (swiper) => {
				setDisabledState(swiper, 'trust-us__arrow');
			});
		});
}

// function showHint (hintElement) {
// 	hintElement.style.opacity = '1';
// 	hintElement.style.zIndex = '99999';
// 	hintElement.style.transform = 'translate(-85%, 0)';
// 	hintElement.parentElement.setAttribute('data-show-hint', 'true');
// }
//
// function hideHint (hintElement) {
// 	hintElement.style.opacity = '0';
// 	hintElement.style.zIndex = '1';
// 	hintElement.style.transform = 'translate(-85%, 8px)';
// 	hintElement.parentElement.setAttribute('data-show-hint', 'false');
// }
function showHint (button) {
	addClassToElement(button, 'hovered');
	button.setAttribute('data-show-hint', 'true');
}

function hideHint (button) {
	removeClassFromElement(button, 'hovered');
	button.setAttribute('data-show-hint', 'false');
}

function hideAllHints () {
	const hintButtons = document.querySelectorAll('button[data-show-hint="true"]');

	if (!hintButtons.length) {
		return;
	}

	hintButtons.forEach(hideHint);
}

function toggleHint (button, state) {
	if (!button) {
		return;
	}

	hideAllHints();

	if (state !== 'true') {
		showHint(button);
	}
}

function isMobile() {
	return innerWidth <= 480;
}

const hintButtons = Array.from(document.querySelectorAll('button[data-show-hint]'));

hintButtons.forEach(button => {
	button.addEventListener('mouseover', (e) => {
		// if (isMobile()) {
		// 	return;
		// }

		showHint(button);
	});
	button.addEventListener('mouseleave', (e) => {
		// if (isMobile()) {
		// 	return;
		// }

		hideHint(button);
	});
	button.addEventListener('touchend', (e) => {
		// const button = e.target.closest('button');
		toggleHint(button, button.dataset.showHint);
	});
});

function disableOptions (ulElement, ...optionIds) {
	const listElements = Array.from(ulElement.children);

	listElements.forEach(li => {
		const anchorElement = li.firstElementChild;
		const { dataset } = anchorElement;

		if (dataset && dataset.value && optionIds.includes(dataset.value)) {
			addClassToElement(li, 'buy__form-control', '--excluded');
			anchorElement.textContent = `${dataset.text} ${labels.unavailableForStart}`;
		}
	});

}

function enableAllOptions () {
	const listElements = Array.from(document.getElementsByClassName('buy__form-control--excluded'));

	listElements.forEach(li => {
		const anchorElement = li.firstElementChild;
		const { dataset } = anchorElement;

		if (dataset && dataset.text) {
			anchorElement.textContent = dataset.text;
		}

		removeClassFromElement(li, 'buy__form-control', '--excluded');
	});
}

function checkPaymentResult(order_id, step = 10 * 1000) {
	const loader = document.getElementById('loader-modal');

	if (!order_id) {
		hideCurrentModal({target: loader});
		return;
	}

	const statuses = {
		CREATED: 1,
		PAID: 2,
		CANCELLED: 3,
	}
	const interval = setInterval((order_id) => {
		sendRequestAndSaveToken('/api/get_status_policy', {
			method: 'POST', body:JSON.stringify({ order_id })
		}).then(({ response }) => {
			if (!response || !response.success) {
				clearInterval(interval);
				hideCurrentModal({target: loader});
				showModalById('error-modal');
			}

			// if (!Obect.keys(statuses).includes(response.status)) {
			// 	clearInterval(interval);
			// 	hideCurrentModal({target: loader});
			// 	showModalById('error-modal');
			// }

			switch (response.status) {
				case statuses.CANCELLED:
					clearInterval(interval);
					hideCurrentModal({target: loader});
					showModalById('expired-modal');

					return;
				case statuses.PAID:
					const addTouristButton = document.querySelector('button[data-tourist="add"]');
					// const { origin } = window.location;
					//
					// window.location.replace(`${origin}/thanks`);
					clearInterval(interval);
					hideCurrentModal({target: loader});
					scrollToElement(buyForm, 400);
					showModalById('success-payment-modal');
					setBuyFormStep(0);
					addTouristButton && updateTourists({tourist: 'removeAll', id: null}, addTouristButton);
					updateWrapperStyles();
					resetForm();
					updateBuyFormPrice();

					return;
				default:
					return;
			}

		}).catch(e => console.error(e.message));
	}, step, order_id);
}
function isElementPartiallyVisible(element) {
	if (!element || !element.nodeType) {
		return false;
	}

	const rect = element.getBoundingClientRect();
	const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

	return (
		rect.bottom > 0 &&
		rect.right > 0 &&
		rect.top < viewportHeight &&
		rect.left < viewportWidth
	);
}

function getUsersQueryParams() {
	const searchParams = window.location.search;

	// Return empty object if no query string
	if (!searchParams || searchParams.length <= 1) {
		return {};
	}

	const params = {};

	// Remove leading '?' and split by '&'
	const pairs = searchParams.substring(1).split('&');

	pairs.forEach(pair => {
		if (!pair) return;

		const [key, value] = pair.split('=');

		// Decode URI components
		const decodedKey = decodeURIComponent(key);
		const decodedValue = value ? decodeURIComponent(value) : '';

		// Handle multiple values for same key (convert to array)
		if (params.hasOwnProperty(decodedKey)) {
			if (Array.isArray(params[decodedKey])) {
				params[decodedKey].push(decodedValue);
			} else {
				params[decodedKey] = [params[decodedKey], decodedValue];
			}
		} else {
			params[decodedKey] = decodedValue;
		}
	});

	return params;
}

function scrollToLastAddedTerritory(offset = 0) {
	// Find the multiselect list container
	const multiselectList = document.querySelector('.buy__form-control--multiselect-list');

	if (!multiselectList) {
		console.error('Multiselect list not found');
		return;
	}

	// Find all list items (excluding the input)
	const listItems = multiselectList.querySelectorAll('.buy__form-control--multiselect-list-item');

	if (listItems.length === 0) {
		console.warn('No territory items found');
		return;
	}

	// Get the last item
	const lastItem = listItems[listItems.length - 1];

	// Get the position of the last item relative to the container
	const containerRect = multiselectList.getBoundingClientRect();
	const itemRect = lastItem.getBoundingClientRect();

	// Calculate the horizontal scroll position
	const scrollLeft = multiselectList.scrollLeft;
	const targetScrollX = scrollLeft + (itemRect.left - containerRect.left) + offset;

	// Scroll horizontally only
	multiselectList.scrollTo({
		left: targetScrollX,
		behavior: 'smooth'
	});

	return lastItem;
}

function sendInfoGa(event_id = '', params_add = {}) {
	if (!event_id) {
		return;
	}

	const body = validateForm(buyForm);
	const token = params_add.token || null;

	body.countries = multiSelect.getSelectEntries()
		.map(([text]) => text)
		.join(', ');
	body.duration = daysDiff(body.date);


	const { details, insurer, tourists } = groupUpBuyFormBody(body);
	const { name, lastname, passport, birthday } = insurer;

	if (!tourists.length && name && lastname && passport && birthday) {
		tourists.push({ name, lastname, passport, birthday });
	}

	const events_arr = [
		{ id: 1, name: 'view_item' },  			// Form in view
		{ id: 2, name: 'add_to_cart' },			// Second form body
		{ id: 3, name: 'begin_checkout' },		// Third form body
		{ id: 4, name: 'add_shipping_info' },	// Submit form
		{ id: 5, name: 'add_payment_info' },	// Temp payment page
		{ id: 6, name: 'purchase' },			// Thanks page, successful payment
	];
	const prev_step = Number(localStorage.getItem('ga_step'));
	const current_step = Number(event_id);
	const event_obj = events_arr
		.find(item => item.id === event_id);

	if (!event_obj || prev_step >= current_step) {
		return;
	}

	const tariffs_associations = {
		'6': 11,
		'11': 22,
		'3': 33,
	};
	const item_names = {
		'3': 'Max+',
		'6': 'Start',
		'11': 'Gold',
	};
	const rest_type_names = {
		// '1': 'Calm rest',
		'1': 'Calm',
		// '2': 'Active rest',
		'2': 'Active',
		'3': 'Extreme',
		'4': 'Sport',
		'34': 'Study',
		'35': 'Work',
		'36': 'Cruise',
	};
	const promoCodeInputs = Array.from(document.querySelectorAll('input[name="promo"]'))
		.filter(({ parentElement }) => parentElement.classList.contains('buy__form-promo--success'));
	const price = localStorage.getItem('price');
	const currency = "USD";
	let coupon = '';

	if (promoCodeInputs.length) {
		coupon = promoCodeInputs[0].value;
	}

	return sendRequestAndSaveToken('/api/sendInfoGa', {
		method: 'POST',
		body: JSON.stringify({
			event: event_obj.name,
			client_id: getClientIdGa(),
			params: {
				// session_id: getSessionIdFromCookie('1WV35MRRLY'),
				session_id: getSessionIdFromCookie('32YEZ1B3BC'),
				items: [
					{
						item_id: tariffs_associations[details.tariff_id],
						item_name: item_names[details.tariff_id],
						quantity: 1,
						coupon,
						item_category: details.duration + ' days',			// Trip duration
						item_category2: details.countries,					// Countries list
						item_category3: rest_type_names[details.type_id],	// Rest type text
						item_category4: tourists.length,					// Tourists count
						item_variant: params_add.order_id || 0, 			// Policy number
						price,
						currency,
					}
				],
				coupon,
				currency,
				value: price,
			}
		})
	}).then(({ response }) => {
		localStorage.setItem('ga_step', current_step.toString());
	});
}

// function sendInfoGaOld(event_id = '', params_add = {}) {
// 	if (!event_id) {
// 		return;
// 	}
//
// 	const body = validateForm(buyForm);
//
// 	body.countries = multiSelect.getSelectEntries()
// 		.map(([text]) => text)
// 		.join(', ');
// 	body.duration = daysDiff(body.date);
//
//
// 	const { details, insurer, tourists } = groupUpBuyFormBody(body);
// 	const { name, lastname, passport, birthday } = insurer;
//
// 	if (!tourists.length && name && lastname && passport && birthday) {
// 		tourists.push({ name, lastname, passport, birthday });
// 	}
//
// 	// debugger;
//
// 	const events_arr = [
// 		{ id: 2, name: 'add_to_cart' },			// Second form body
// 		{ id: 3, name: 'begin_checkout' },		// Third form body
// 		{ id: 6, name: 'purchase' },			// Thanks page, successful payment
// 	];
// 	const prev_step = Number(localStorage.getItem('ga_old_step'));
// 	const current_step = Number(event_id);
// 	const event_obj = events_arr
// 		.find(item => item.id === event_id);
//
// 	if (!event_obj || prev_step >= current_step) {
// 		return;
// 	}
//
// 	const tariffs_associations = {
// 		'3': 108,
// 		'6': 44,
// 		'11': 107,
// 	};
// 	const item_names = {
// 		'3': 'max_plus',
// 		'6': 'start',
// 		'11': 'gold',
// 	};
// 	const coupon = details.promo;
// 	const price = localStorage.getItem('price');
// 	const currency = "USD";
//
// 	sendRequestAndSaveToken('/api/sendInfoGaOld', {
// 		method: 'POST',
// 		body: JSON.stringify({
// 			event: event_obj.name,
// 			client_id: getClientIdGa(),
// 			params: {
// 				session_id: getSessionIdFromCookie('9FJMKGEBBH'),
// 				items: [
// 					{
// 						item_name: item_names[details.tariff_id],
// 						item_id: tariffs_associations[details.tariff_id],
// 						quantity: 1,
// 						price,
// 						currency,
// 						item_variant:  0,
// 					}
// 				],
// 				currency,
// 				value: price,
// 				// "transaction_id": msg.data.orderNo,
// 			}
// 		})
// 	}).then(({ response }) => {
// 		localStorage.setItem('ga_old_step', current_step.toString());
// 	});
// }

function sendInfoFba(event_id = ''){
	if(event_id){
		let last_event_step = parseInt(localStorage.getItem('analytics_form_step'))

		if(event_id > last_event_step){
			let fba_event_data = {1: "AddToCart", 2: "InitiateCheckout", 3: "CompleteRegistration", 4: "AddPaymentInfo", 5: "Purchase"}
			let event_name = fba_event_data[event_id];
			let value = localStorage.getItem('price');
			let request = {event_name, value};

			sendRequestAndSaveToken('/api/sendInfoFba', {
				method: 'POST',
				body: JSON.stringify(request)
			}).then(({ response }) => {
				localStorage.setItem('analytics_form_step', event_id)
			});
		}
	}
}

function getClientIdGa() {
	var match = document.cookie.match('(?:^|;)\\s*_ga=([^;]*)');
	var raw = (match) ? decodeURIComponent(match[1]) : null;
	if (raw) {
		match = raw.match(/(\d+\.\d+)$/);
	}
	var gacid = (match) ? match[1] : null;
	if (gacid) {
		return gacid;
	}
}

function getSessionIdFromCookie(measurementId) {
	const cookieName = `_ga_${measurementId}`;

	const cookieValue = document.cookie
		.split('; ')
		.find(row => row.startsWith(cookieName + '='))
		?.split('=')[1];

	if (!cookieValue) return null;

	const match = cookieValue.match(/s(\d+)/);
	if (!match) return null;

	return Number(match[1]);
}

function getPromoFromURLParams () {
	return (new URLSearchParams(window.location.search)).get('promotion');
}

function getStartTariffButtons () {
	return Array.from(document.querySelectorAll('button[data-set-input="tariff"][data-value="6"]'));
}
function disableStartTariffButtons () {
	const buttons = getStartTariffButtons();

	buttons.forEach(button => {
		if (button.hasAttribute('data-disabled')) {
			return;
		}

		button.setAttribute('data-disabled', true)
	});
}

function enableStartTariffButtons () {
	const buttons = getStartTariffButtons();

	buttons.forEach(button => {
		if (button.hasAttribute('data-disabled')) {
			button.removeAttribute('data-disabled');
		}
	});
}

function updateURLSearch(params) {
	// Validate params
	if (!params || typeof params !== 'object') {
		console.error('Invalid params: must be an object');
		return;
	}

	// Get current URL search params
	const searchParams = new URLSearchParams(window.location.search);

	// Update or add parameters
	Object.keys(params).forEach(key => {
		const value = params[key];

		if (value === null || value === undefined || value === '') {
			// Remove parameter if value is null, undefined, or empty string
			searchParams.delete(key);
		} else if (Array.isArray(value)) {
			// Handle array values
			searchParams.delete(key); // Remove existing first
			value.forEach(v => {
				if (v !== null && v !== undefined && v !== '') {
					searchParams.append(key, v);
				}
			});
		} else {
			// Set or update single value
			searchParams.set(key, value);
		}
	});

	// Build new URL
	const newSearch = searchParams.toString();
	const newURL = newSearch
		? `${window.location.pathname}?${newSearch}${window.location.hash}`
		: `${window.location.pathname}${window.location.hash}`;

	// Update URL without page reload
	window.history.pushState({}, '', newURL);

	return newURL;
}
//
// function loadScalioLib () {
// 	const urlScalio = 'https://insuranceaffiliate.online/click';
// 	const url = new URL(document.location.href).searchParams;
// 	const clickId = url.get('click_id');
// 	const aParam = url.get('a');
// 	const oParam = '1'; // Product number from Scalio dashboard
//
// 	if (clickId || !aParam) {
// 		return;
// 	}
//
// 	const availableParams = [
// 		'aff_click_id',
// 		'sub_id1',
// 		'sub_id2',
// 		'sub_id3',
// 		'sub_id4',
// 		'sub_id5',
// 		'aff_param1',
// 		'aff_param2',
// 		'aff_param3',
// 		'aff_param4',
// 		'aff_param5',
// 		'idfa',
// 		'gaid',
// 	];
// 	const params = [
// 		`a=${aParam}`,
// 		`o=${oParam}`,
// 		'return=click_id',
// 	];
//
// 	if (availableParams?.length > 0) {
// 		availableParams.forEach((key) => {
// 			const value = url.get(key);
// 			if (value) {
// 				params.push(`${key}=${value}`);
// 			}
// 		});
// 	}
//
// 	console.log(params);
//
// 	sendRequestAndSaveToken('/api/get_scalio_click_id', {
// 		method: 'POST',
// 		body: JSON.stringify({ params }),
// 	}).then(({ response }) => {
// 		console.log(response);
// 		// updateURLSearch({
// 		// 	a: null,
// 		// 	o: null,
// 		// 	affid: aParam,
// 		// 	offid: oParam,
// 		// 	click_id,
// 		// })
// 	});
//
//
// 	// const t = new URL(urlScalio);
// 	// const r = t.searchParams;
// 	// r.append('a', url.get('a'));
// 	// r.append('o', oParam);
// 	// r.append('return', 'click_id');
// 	//
// 	// if (availableParams?.length > 0) {
// 	// 	availableParams.forEach((key) => {
// 	// 		const value = url.get(key);
// 	// 		if (value) {
// 	// 			r.append(key, value);
// 	// 		}
// 	// 	});
// 	// }
// 	//
// 	// sendRequestAndSaveToken(t.href).then(({ click_id }) => updateURLSearch({
// 	// 	a: null,
// 	// 	o: null,
// 	// 	affid: aParam,
// 	// 	offid: oParam,
// 	// 	click_id,
// 	// }));
// }

function setDottedDateFormat(date) {
	return [
		date.getDate(),
		date.getMonth() + 1,
		date.getFullYear()
	].map(n => n < 10 ? `0${n}`: `${n}`).join('.');
}

function getFormatDates(dateStr) {
	if (!dateStr) {
		return ['', ''];
	}

	const [day, month, year] = dateStr.split('.').map(Number);
	const subscription_duration = 29;

	const date = new Date(year, month - 1, day);
	const future = new Date(date);

	future.setDate(future.getDate() + subscription_duration);

	return [setDottedDateFormat(date), setDottedDateFormat(future)];
}

function updateDateInputMask (input, formattedDate) {

	if (!input) {
		return;
	}

	const [ start, end ] = formattedDate;

	if (!start) {
		input.nextElementSibling.innerHTML = '';

		return;
	}

	input.nextElementSibling.innerHTML = `<span>${start}</span>${defaults.date_separator}${end}`;
}

function switchDateInputs (isSubscription) {
	const travelDateInput = document.getElementById('date');
	const subscriptionDateInput =  document.getElementById('subscription_date');
	const groupClassName = 'buy__form-group';

	if (!travelDateInput || !subscriptionDateInput) {
		return;
	}

	const index = Number(isSubscription);
	const inputs = [
		subscriptionDateInput,
		travelDateInput,
	];

	inputs.forEach((input, idx) => {
		const groupElement = input.closest('.' + groupClassName);
		const modifier = '--hidden';

		if (!groupElement) {
			return;
		}

		if (idx === index) {
			removeClassFromElement(groupElement, groupClassName, modifier);
		} else {
			addClassToElement(groupElement, groupClassName, modifier);
		}
	})
}

function dynamicTextTyping () {
	const words = [
		labels.dynamicTitleOne,
		labels.dynamicTitleTwo,
	];

	let wordIndex = 0;
	let charIndex = 0;
	let isDeleting = false;

	const textElement = document.getElementById("dynamic_text");

	function type() {
		const currentWord = words[wordIndex];

		if (isDeleting) {
			charIndex--;
		} else {
			charIndex++;
		}

		textElement.textContent = currentWord.substring(0, charIndex);

		let speed = isDeleting ? 50 : 100;

		if (!isDeleting && charIndex === currentWord.length) {
			speed = 1500; // pause at end
			isDeleting = true;
		} else if (isDeleting && charIndex === 0) {
			isDeleting = false;
			wordIndex = (wordIndex + 1) % words.length;
			speed = 500; // pause before next word
		}

		setTimeout(type, speed);
	}

	if (textElement) {
		type();
	}
}


let observer = new IntersectionObserver(([entry], observer) => {
	if (!entry.isIntersecting) return;
	sendInfoGa(1);
	observer.unobserve(entry.target);
}, {
	threshold: 0.5
})

observer.observe(buyForm);

function getFlowId() {
	const prefix = 'ekta_insure_flow_';

	if (window.name && window.name.startsWith(prefix)) {
		return window.name.replace(prefix, '');
	}

	const id = (crypto.randomUUID && crypto.randomUUID())
		? crypto.randomUUID()
		: Math.random().toString(36).substr(2, 9);

	window.name = prefix + id;

	return id;
}


// function saveClientActivity(active_step = 0){
// 	if(active_step){
// 		let error_arr = [];
// 		let date = getDate();
// 		let date_from = changeDateFormat(date[0]);
// 		let date_to = changeDateFormat(date[1]);
// 		let date_reg_to = /^\d{4}-\d{2}-\d{2}$/gi;
// 		let date_reg_from = /^\d{4}-\d{2}-\d{2}$/gi;
//
// 		let date_from_valid = (date_reg_from.test(date_from))
// 		let date_to_valid = (date_reg_to.test(date_to))
//
// 		let countries = getCountries();
// 		let countries_valid = (Array.isArray(countries) && countries.length !== 0)
//
// 		let year_program = $('#annual_policy').checked;
// 		let already_traveling = $('#already_travel').checked;
// 		let expat = $('#expat').checked;
// 		let subscription = $('#subscription').checked;
//
// 		let coverage_id = parseInt($('#insured_amount').dataset.id)
// 		let coverage_id_valid = (coverage_id > 0 && !isNaN(coverage_id))
//
// 		let currency_id = parseInt($('#insured_amount').dataset.currency_id)
// 		let currency_id_valid = (currency_id > 0 && !isNaN(currency_id))
//
// 		let travel_type = parseInt($('#type_rest').dataset.id) // > 0 || isNaN()
// 		let travel_type_valid = (travel_type > 0 && !isNaN(travel_type))
//
// 		let additional_services = getAdditionalService()
// 		let additional_services_valid = (Array.isArray(additional_services))
//
// 		let tourists = getTourists()
// 		let tourists_valid = (Array.isArray(tourists) && tourists.length !== 0);
//
// 		let promo_code = null
// 		let promo_code_valid = true
// 		if ($('#check_promo').checked) {
// 			promo_code = $('#promo_code').value.trim()
// 			promo_code_valid = (promo_code.length > 0)
// 		}
//
// 		let insurer = getInsurer();
// 		let insurer_valid = false;
//
// 		if (insurer.success) {
// 			insurer = insurer.insurer_obj;
// 			insurer_valid = true;
// 		}
//
// 		if (!insurer_valid) {
// 			error_arr.push('insurer')
// 		}
// 		if (!date_to_valid) {
// 			error_arr.push('date_to')
// 		}
// 		if (!date_from_valid) {
// 			error_arr.push('date_from')
// 		}
// 		if (!countries_valid) {
// 			error_arr.push('countries')
// 		}
// 		if (!coverage_id_valid) {
// 			error_arr.push('coverage')
// 		}
// 		if (!currency_id_valid) {
// 			error_arr.push('currency_id')
// 		}
// 		if (!travel_type_valid) {
// 			error_arr.push('travel_type')
// 		}
// 		if (!additional_services_valid) {
// 			error_arr.push('additional_services')
// 		}
// 		if (!tourists_valid) {
// 			error_arr.push('tourists')
// 		}
// 		if (!promo_code_valid) {
// 			error_arr.push('promo_code_valid')
// 		}
//
// 		if(error_arr.length === 0){
//
// 			let request = {
// 				active_step,
// 				"product_data" : {
// 					"active_flow": getFlowId(),
// 					date_from,
// 					date_to,
// 					countries,
// 					year_program,
// 					already_traveling,
// 					expat,
// 					subscription,
// 					coverage_id,
// 					currency_id,
// 					travel_type,
// 					tourists,
// 					promo_code,
// 					additional_services,
// 					insurer
// 				}
// 			}
//
// 			makeRequest('POST', '/api/saveClientActivity', request).then((data) => {
// 				if (data) {
// 					let token = data?.token ?? '';
// 					setToken(token)
// 				}
// 			})
// 		}
// 	}
// }

function saveClientActivity(active_step = 0, additional_data = {}) {
	const body = validateForm(buyForm);

	body.countries = multiSelect.getSelectEntries()
		.map(([text]) => text)
		.join(', ');
	body.duration = daysDiff(body.date);


	const { details, insurer, tourists } = groupUpBuyFormBody(body);
	const { name, lastname, passport, birthday } = insurer;

	insurer.fullname = `${name} ${lastname}`;
	insurer.date_birth = birthday;

	if (!tourists.length && name && lastname && passport && birthday) {
		tourists.push({ name, lastname, passport, birthday });
	}

	// const isDiscount = timer.showCurrentTimestamp() > 0;
	const {
		date_from, date_to, countries, program_id,
		already_traveling, promo_code, travel_type, is_subscription
	} = normalizeDetails(details);
	const currency_id = 1;

	const requestBody = {
		active_step,
		product_data : {
			active_flow: getFlowId(),
			date_from,
			date_to,
			countries,
			year_program: false,
			already_traveling,
			expat: false,
			subscription: is_subscription,
			coverage_id: program_id,
			currency_id,
			travel_type,
			tourists,
			promo_code,
			additional_services: [],
			insurer,
			...additional_data,
		}
	};

	const serializedBody = JSON.stringify(requestBody);

	// Skip request if body hasn't changed since last call
	if (serializedBody === saveClientActivity.lastSentBody) {
		return;
	}

	saveClientActivity.lastSentBody = serializedBody;

	sendRequestAndSaveToken('/api/filling_analytics_clients_activity', {
		method: 'POST',
		body: serializedBody,
	});
}

function showInfoHint(e) {
	const hint = e.currentTarget.closest('.hint');

	if (hint && hint.dataset.text) {
		e.currentTarget.closest('.hint').classList.add('hover');
	}
}
function hideInfoHint(e) { e.currentTarget.closest('.hint').classList.remove('active', 'hover'); }
function toggleInfoHint (e) {
	const { target } = e;
	const activeClassName = 'active';
	const hint = target.closest('.hint');

	if (hint && hint.dataset.text) {
		hint.classList.remove('hover');
		hint.classList.toggle(activeClassName);
	} else {
		Array.from(document.getElementsByClassName('hint'))
			.forEach(hint => hint.classList.remove(activeClassName))
	}
}

document.body.addEventListener('click', toggleInfoHint);
document.querySelectorAll('.hint').forEach(button => {
	button.addEventListener('mouseenter', showInfoHint);
	button.addEventListener('mouseleave', hideInfoHint);
});

function bytesToStr(bytes) {
	const units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB'];
	let i = 0;

	while (bytes >= 1024 && i < units.length - 1) {
		bytes /= 1024;
		i++;
	}

	return `${bytes % 1 === 0 ? bytes : bytes.toFixed(2)}${units[i]}`;
}

function replaceTextVariables(text, variables = {}) {
	return text.replace(/\{\{(\w+)}}/g, (_, key) => variables[key] ?? '');
}

function formatESIMCountryNames(countries) {
	const limit = 3;
	const visibleCountries = countries.slice(0, limit).join(', ');
	const remainingCount = countries.length - limit;

	if (remainingCount <= 0) {
		return visibleCountries;
	}

	return `${visibleCountries} +${remainingCount}`;
}

function setMessageESIM(countries, esim_info) {
	const countriesList = formatESIMCountryNames(countries);

	if (!esim_info) {
		const notServed = countries.length === 1 ? labels.esimNotServed : labels.esimNotServedMany;

		return replaceTextVariables(notServed, { countries: countriesList });
	}

	const { count_bytes, duration, paid_esim } = esim_info;
	const served = paid_esim ? labels.esimServedIncluded :  labels.esimServed;

	return replaceTextVariables(served, {
		countries: countriesList,
		bytes: bytesToStr(count_bytes),
		duration,
	});
}
function updateInfoESIM(esim_info) {
	const { groupWrapper, getSelectEntries } = multiSelect
	const labelElement = groupWrapper.querySelector('p[data-text]');
	const countries = getSelectEntries().map(([text]) => text.replace(/\s*\([^)]*\)/g, '').trim());
	const isEmpty = countries.length === 0;
	const message = setMessageESIM(countries, esim_info);

	groupWrapper.classList.toggle('buy__form-group--esim', !isEmpty);
	labelElement.textContent = isEmpty ? labelElement.dataset.text : message;
}


}init();